(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired444"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired444"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("6Ny6s", function(module, exports) {

$parcel$export(module.exports, "formatMoney", () => $4f31c5d55b61de56$export$a17b3c2052469c69);
$parcel$export(module.exports, "fetchCartData", () => $4f31c5d55b61de56$export$6a814fef09afa7ac);
$parcel$export(module.exports, "hideCartModal", () => $4f31c5d55b61de56$export$569d845562b165b0);
$parcel$export(module.exports, "showAddToCartPreview", () => $4f31c5d55b61de56$export$b2ae74634740021f);
$parcel$export(module.exports, "showCartHoverPreview", () => $4f31c5d55b61de56$export$c2b9dca3fec345a8);
// --------------------------------
// Format a number of cents into USD currency format
// --------------------------------
function $4f31c5d55b61de56$export$a17b3c2052469c69(cents) {
    return `$${(cents / 100).toFixed(2)}`;
}
function $4f31c5d55b61de56$export$7a2e37b19de8e5a6(item) {
    return `
    <div class="cart-preview-item">
      ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-item-image">` : ""}
      <div class="cart-item-details">
        <h4>${item.title}</h4>
        <p>Qty: ${item.quantity}</p>
        <p class="price">${$4f31c5d55b61de56$export$a17b3c2052469c69(item.line_price)}</p>
      </div>
    </div>
  `;
}
function $4f31c5d55b61de56$export$6247a3368ba0dc10(items, totalPrice, addToCart = false, cartItemKey = null) {
    const MAX_VISIBLE_ITEMS = 3;
    const hasMultipleItems = items.length > 1;
    const isScrollable = items.length > MAX_VISIBLE_ITEMS;
    let displayedItems = items;
    // Check if it is an add-to-cart preview
    // If so, filter out the item being added if it exists
    if (addToCart && cartItemKey) displayedItems = items.filter((item)=>item.key !== cartItemKey);
    const cartItemsHTML = displayedItems.map($4f31c5d55b61de56$export$7a2e37b19de8e5a6).join("");
    // Show total price only if there are multiple items and is add-to-cart preview or if addToCart is false
    const shouldShowTotal = !addToCart || addToCart && hasMultipleItems;
    return `
    <div class="cart-preview">
      <div class="cart-items-wrapper${isScrollable ? " scrollable" : ""}">
        ${cartItemsHTML}
      </div>
      ${shouldShowTotal ? `
        <div class="cart-total">
          <p id="cart-total">Total: ${$4f31c5d55b61de56$export$a17b3c2052469c69(totalPrice)}</p>
        </div>
      ` : ""}
    </div>
  `;
}
async function $4f31c5d55b61de56$export$6a814fef09afa7ac() {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart data");
    return await response.json();
}
function $4f31c5d55b61de56$export$8de661b730965f3e(html) {
    const cartMessage = document.getElementById("cart-message");
    const cartItem = document.getElementById("cart-item");
    if (!cartMessage || !cartItem) {
        console.error("Cart modal elements missing");
        return;
    }
    cartItem.innerHTML = html;
    cartMessage.style.display = "block";
    cartMessage.classList.add("active");
}
function $4f31c5d55b61de56$export$569d845562b165b0() {
    const cartMessage = document.getElementById("cart-message");
    if (cartMessage) {
        cartMessage.classList.remove("active");
        setTimeout(()=>{
            cartMessage.style.display = "none";
        }, 300);
    }
}
// --------------------------------
// Generic function to fetch cart data and display a preview modal
// Behavior is controlled by options passed in
// --------------------------------
async function $4f31c5d55b61de56$var$showCartPreview({ addToCart: addToCart = false, useAddToCartWrapper: useAddToCartWrapper = false, cartItemKey: cartItemKey = null }) {
    try {
        const cartData = await $4f31c5d55b61de56$export$6a814fef09afa7ac();
        if (!cartData.items?.length) {
            $4f31c5d55b61de56$export$569d845562b165b0();
            return;
        }
        const html = $4f31c5d55b61de56$export$6247a3368ba0dc10(cartData.items, cartData.total_price, addToCart, cartItemKey);
        const wrapper = document.getElementById("cart-preview-wrapper");
        if (useAddToCartWrapper) // Show in the dedicated add-to-cart preview wrapper
        {
            if (wrapper) {
                wrapper.innerHTML = html;
                wrapper.style.display = "block";
            }
        } else {
            // Show in the main cart modal
            $4f31c5d55b61de56$export$8de661b730965f3e(html);
            // Hide add-to-cart preview wrapper if it was open
            if (wrapper) {
                wrapper.innerHTML = "";
                wrapper.style.display = "none";
            }
        }
    } catch (error) {
        console.error(addToCart ? "Add-to-cart error:" : "Cart hover error:", error);
    }
}
function $4f31c5d55b61de56$export$b2ae74634740021f(cartItemKey) {
    return $4f31c5d55b61de56$var$showCartPreview({
        addToCart: true,
        useAddToCartWrapper: true,
        cartItemKey: cartItemKey
    });
}
function $4f31c5d55b61de56$export$c2b9dca3fec345a8() {
    return $4f31c5d55b61de56$var$showCartPreview({
        addToCart: false,
        useAddToCartWrapper: false
    });
}

});

parcelRegister("hRgcM", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("lvdU8")).then(()=>parcelRequire("1NSUj"));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case "preload":
            return $55a6d16921f8ab25$var$cachedPreloads;
        case "prefetch":
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $85c3d2569221a469$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("f5dQu"), JSON.parse('["f5dQu","main.parcel.js","lvdU8","router.parcel.d9873de8.js","dlBC6","page-index.parcel.6f819bdd.js","alGBp","page-index.7c82cb71.js","cLklC","page-index.7edd3135.js","jdQO8","page-index.b5420b60.css","3piaI","page-collection.parcel.79436930.js","fB3G2","page-collection.b00e6427.css","2pFUr","page-product.parcel.081172c2.js","5vEui","page-product.8a34541b.css","bo14t","page-cart.parcel.681299ab.js","3kfSV","page-account.parcel.5c57ba97.js","kM1nC","page-addresses.parcel.87394a8d.js"]'));

// packages/alpinejs/src/scheduler.js
var $f347e48613385d9c$var$flushPending = false;
var $f347e48613385d9c$var$flushing = false;
var $f347e48613385d9c$var$queue = [];
var $f347e48613385d9c$var$lastFlushedIndex = -1;
function $f347e48613385d9c$var$scheduler(callback) {
    $f347e48613385d9c$var$queueJob(callback);
}
function $f347e48613385d9c$var$queueJob(job) {
    if (!$f347e48613385d9c$var$queue.includes(job)) $f347e48613385d9c$var$queue.push(job);
    $f347e48613385d9c$var$queueFlush();
}
function $f347e48613385d9c$var$dequeueJob(job) {
    let index = $f347e48613385d9c$var$queue.indexOf(job);
    if (index !== -1 && index > $f347e48613385d9c$var$lastFlushedIndex) $f347e48613385d9c$var$queue.splice(index, 1);
}
function $f347e48613385d9c$var$queueFlush() {
    if (!$f347e48613385d9c$var$flushing && !$f347e48613385d9c$var$flushPending) {
        $f347e48613385d9c$var$flushPending = true;
        queueMicrotask($f347e48613385d9c$var$flushJobs);
    }
}
function $f347e48613385d9c$var$flushJobs() {
    $f347e48613385d9c$var$flushPending = false;
    $f347e48613385d9c$var$flushing = true;
    for(let i = 0; i < $f347e48613385d9c$var$queue.length; i++){
        $f347e48613385d9c$var$queue[i]();
        $f347e48613385d9c$var$lastFlushedIndex = i;
    }
    $f347e48613385d9c$var$queue.length = 0;
    $f347e48613385d9c$var$lastFlushedIndex = -1;
    $f347e48613385d9c$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f347e48613385d9c$var$reactive;
var $f347e48613385d9c$var$effect;
var $f347e48613385d9c$var$release;
var $f347e48613385d9c$var$raw;
var $f347e48613385d9c$var$shouldSchedule = true;
function $f347e48613385d9c$var$disableEffectScheduling(callback) {
    $f347e48613385d9c$var$shouldSchedule = false;
    callback();
    $f347e48613385d9c$var$shouldSchedule = true;
}
function $f347e48613385d9c$var$setReactivityEngine(engine) {
    $f347e48613385d9c$var$reactive = engine.reactive;
    $f347e48613385d9c$var$release = engine.release;
    $f347e48613385d9c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f347e48613385d9c$var$shouldSchedule) $f347e48613385d9c$var$scheduler(task);
                else task();
            }
        });
    $f347e48613385d9c$var$raw = engine.raw;
}
function $f347e48613385d9c$var$overrideEffect(override) {
    $f347e48613385d9c$var$effect = override;
}
function $f347e48613385d9c$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f347e48613385d9c$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f347e48613385d9c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $f347e48613385d9c$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $f347e48613385d9c$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$f347e48613385d9c$var$release(effectReference);
}
// packages/alpinejs/src/utils/dispatch.js
function $f347e48613385d9c$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f347e48613385d9c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f347e48613385d9c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f347e48613385d9c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f347e48613385d9c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f347e48613385d9c$var$started = false;
function $f347e48613385d9c$var$start() {
    if ($f347e48613385d9c$var$started) $f347e48613385d9c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f347e48613385d9c$var$started = true;
    if (!document.body) $f347e48613385d9c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f347e48613385d9c$var$dispatch(document, "alpine:init");
    $f347e48613385d9c$var$dispatch(document, "alpine:initializing");
    $f347e48613385d9c$var$startObservingMutations();
    $f347e48613385d9c$var$onElAdded((el)=>$f347e48613385d9c$var$initTree(el, $f347e48613385d9c$var$walk));
    $f347e48613385d9c$var$onElRemoved((el)=>$f347e48613385d9c$var$destroyTree(el));
    $f347e48613385d9c$var$onAttributesAdded((el, attrs)=>{
        $f347e48613385d9c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f347e48613385d9c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f347e48613385d9c$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $f347e48613385d9c$var$initTree(el);
    });
    $f347e48613385d9c$var$dispatch(document, "alpine:initialized");
}
var $f347e48613385d9c$var$rootSelectorCallbacks = [];
var $f347e48613385d9c$var$initSelectorCallbacks = [];
function $f347e48613385d9c$var$rootSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f347e48613385d9c$var$allSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.concat($f347e48613385d9c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f347e48613385d9c$var$addRootSelector(selectorCallback) {
    $f347e48613385d9c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$addInitSelector(selectorCallback) {
    $f347e48613385d9c$var$initSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$closestRoot(el, includeInitSelectors = false) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f347e48613385d9c$var$allSelectors() : $f347e48613385d9c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f347e48613385d9c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f347e48613385d9c$var$findClosest(el.parentElement, callback);
}
function $f347e48613385d9c$var$isRoot(el) {
    return $f347e48613385d9c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f347e48613385d9c$var$initInterceptors = [];
function $f347e48613385d9c$var$interceptInit(callback) {
    $f347e48613385d9c$var$initInterceptors.push(callback);
}
function $f347e48613385d9c$var$initTree(el, walker = $f347e48613385d9c$var$walk, intercept = ()=>{}) {
    $f347e48613385d9c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $f347e48613385d9c$var$initInterceptors.forEach((i)=>i(el2, skip));
            $f347e48613385d9c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $f347e48613385d9c$var$destroyTree(root) {
    $f347e48613385d9c$var$walk(root, (el)=>{
        $f347e48613385d9c$var$cleanupAttributes(el);
        $f347e48613385d9c$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $f347e48613385d9c$var$onAttributeAddeds = [];
var $f347e48613385d9c$var$onElRemoveds = [];
var $f347e48613385d9c$var$onElAddeds = [];
function $f347e48613385d9c$var$onElAdded(callback) {
    $f347e48613385d9c$var$onElAddeds.push(callback);
}
function $f347e48613385d9c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f347e48613385d9c$var$onElRemoveds.push(callback);
    }
}
function $f347e48613385d9c$var$onAttributesAdded(callback) {
    $f347e48613385d9c$var$onAttributeAddeds.push(callback);
}
function $f347e48613385d9c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f347e48613385d9c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $f347e48613385d9c$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $f347e48613385d9c$var$observer = new MutationObserver($f347e48613385d9c$var$onMutate);
var $f347e48613385d9c$var$currentlyObserving = false;
function $f347e48613385d9c$var$startObservingMutations() {
    $f347e48613385d9c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f347e48613385d9c$var$currentlyObserving = true;
}
function $f347e48613385d9c$var$stopObservingMutations() {
    $f347e48613385d9c$var$flushObserver();
    $f347e48613385d9c$var$observer.disconnect();
    $f347e48613385d9c$var$currentlyObserving = false;
}
var $f347e48613385d9c$var$queuedMutations = [];
function $f347e48613385d9c$var$flushObserver() {
    let records = $f347e48613385d9c$var$observer.takeRecords();
    $f347e48613385d9c$var$queuedMutations.push(()=>records.length > 0 && $f347e48613385d9c$var$onMutate(records));
    let queueLengthWhenTriggered = $f347e48613385d9c$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($f347e48613385d9c$var$queuedMutations.length === queueLengthWhenTriggered) while($f347e48613385d9c$var$queuedMutations.length > 0)$f347e48613385d9c$var$queuedMutations.shift()();
    });
}
function $f347e48613385d9c$var$mutateDom(callback) {
    if (!$f347e48613385d9c$var$currentlyObserving) return callback();
    $f347e48613385d9c$var$stopObservingMutations();
    let result = callback();
    $f347e48613385d9c$var$startObservingMutations();
    return result;
}
var $f347e48613385d9c$var$isCollecting = false;
var $f347e48613385d9c$var$deferredMutations = [];
function $f347e48613385d9c$var$deferMutations() {
    $f347e48613385d9c$var$isCollecting = true;
}
function $f347e48613385d9c$var$flushAndStopDeferringMutations() {
    $f347e48613385d9c$var$isCollecting = false;
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$deferredMutations);
    $f347e48613385d9c$var$deferredMutations = [];
}
function $f347e48613385d9c$var$onMutate(mutations) {
    if ($f347e48613385d9c$var$isCollecting) {
        $f347e48613385d9c$var$deferredMutations = $f347e48613385d9c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $f347e48613385d9c$var$onElRemoveds.forEach((i)=>i(node));
        $f347e48613385d9c$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $f347e48613385d9c$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f347e48613385d9c$var$scope(node) {
    return $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$closestDataStack(node));
}
function $f347e48613385d9c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f347e48613385d9c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f347e48613385d9c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f347e48613385d9c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f347e48613385d9c$var$closestDataStack(node.parentNode);
}
function $f347e48613385d9c$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $f347e48613385d9c$var$mergeProxyTrap);
}
var $f347e48613385d9c$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $f347e48613385d9c$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $f347e48613385d9c$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $f347e48613385d9c$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f347e48613385d9c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f347e48613385d9c$var$get(data2, path), (value)=>$f347e48613385d9c$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f347e48613385d9c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f347e48613385d9c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f347e48613385d9c$var$magics = {};
function $f347e48613385d9c$var$magic(name, callback) {
    $f347e48613385d9c$var$magics[name] = callback;
}
function $f347e48613385d9c$var$injectMagics(obj, el) {
    Object.entries($f347e48613385d9c$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $f347e48613385d9c$var$interceptor,
                    ...utilities
                };
                $f347e48613385d9c$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $f347e48613385d9c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f347e48613385d9c$var$handleError(e, el, expression);
    }
}
function $f347e48613385d9c$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f347e48613385d9c$var$shouldAutoEvaluateFunctions = true;
function $f347e48613385d9c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f347e48613385d9c$var$shouldAutoEvaluateFunctions;
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f347e48613385d9c$var$evaluate(el, expression, extras = {}) {
    let result;
    $f347e48613385d9c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f347e48613385d9c$var$evaluateLater(...args) {
    return $f347e48613385d9c$var$theEvaluatorFunction(...args);
}
var $f347e48613385d9c$var$theEvaluatorFunction = $f347e48613385d9c$var$normalEvaluator;
function $f347e48613385d9c$var$setEvaluator(newEvaluator) {
    $f347e48613385d9c$var$theEvaluatorFunction = newEvaluator;
}
function $f347e48613385d9c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f347e48613385d9c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f347e48613385d9c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, expression) : $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f347e48613385d9c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f347e48613385d9c$var$evaluatorMemo = {};
function $f347e48613385d9c$var$generateFunctionFromString(expression, el) {
    if ($f347e48613385d9c$var$evaluatorMemo[expression]) return $f347e48613385d9c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $f347e48613385d9c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f347e48613385d9c$var$evaluatorMemo[expression] = func;
    return func;
}
function $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f347e48613385d9c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression));
            if (func.finished) {
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f347e48613385d9c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f347e48613385d9c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f347e48613385d9c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f347e48613385d9c$var$prefixAsString = "x-";
function $f347e48613385d9c$var$prefix(subject = "") {
    return $f347e48613385d9c$var$prefixAsString + subject;
}
function $f347e48613385d9c$var$setPrefix(newPrefix) {
    $f347e48613385d9c$var$prefixAsString = newPrefix;
}
var $f347e48613385d9c$var$directiveHandlers = {};
function $f347e48613385d9c$var$directive(name, callback) {
    $f347e48613385d9c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f347e48613385d9c$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $f347e48613385d9c$var$directiveOrder.indexOf(directive2);
            $f347e48613385d9c$var$directiveOrder.splice(pos >= 0 ? pos : $f347e48613385d9c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f347e48613385d9c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f347e48613385d9c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f347e48613385d9c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f347e48613385d9c$var$outNonAlpineAttributes).map($f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f347e48613385d9c$var$byPriority);
    return directives2.map((directive2)=>{
        return $f347e48613385d9c$var$getDirectiveHandler(el, directive2);
    });
}
function $f347e48613385d9c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f347e48613385d9c$var$toTransformedAttributes()).filter((attr)=>!$f347e48613385d9c$var$outNonAlpineAttributes(attr));
}
var $f347e48613385d9c$var$isDeferringHandlers = false;
var $f347e48613385d9c$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $f347e48613385d9c$var$currentHandlerStackKey = Symbol();
function $f347e48613385d9c$var$deferHandlingDirectives(callback) {
    $f347e48613385d9c$var$isDeferringHandlers = true;
    let key = Symbol();
    $f347e48613385d9c$var$currentHandlerStackKey = key;
    $f347e48613385d9c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f347e48613385d9c$var$directiveHandlerStacks.get(key).length)$f347e48613385d9c$var$directiveHandlerStacks.get(key).shift()();
        $f347e48613385d9c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f347e48613385d9c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f347e48613385d9c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f347e48613385d9c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f347e48613385d9c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f347e48613385d9c$var$evaluateLater.bind($f347e48613385d9c$var$evaluateLater, el),
        evaluate: $f347e48613385d9c$var$evaluate.bind($f347e48613385d9c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f347e48613385d9c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f347e48613385d9c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    $f347e48613385d9c$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f347e48613385d9c$var$isDeferringHandlers ? $f347e48613385d9c$var$directiveHandlerStacks.get($f347e48613385d9c$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f347e48613385d9c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f347e48613385d9c$var$into = (i)=>i;
function $f347e48613385d9c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f347e48613385d9c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f347e48613385d9c$var$attributeTransformers = [];
function $f347e48613385d9c$var$mapAttributes(callback) {
    $f347e48613385d9c$var$attributeTransformers.push(callback);
}
function $f347e48613385d9c$var$outNonAlpineAttributes({ name: name }) {
    return $f347e48613385d9c$var$alpineAttributeRegex().test(name);
}
var $f347e48613385d9c$var$alpineAttributeRegex = ()=>new RegExp(`^${$f347e48613385d9c$var$prefixAsString}([^:^.]+)\\b`);
function $f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f347e48613385d9c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f347e48613385d9c$var$DEFAULT = "DEFAULT";
var $f347e48613385d9c$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f347e48613385d9c$var$DEFAULT,
    "teleport"
];
function $f347e48613385d9c$var$byPriority(a, b) {
    let typeA = $f347e48613385d9c$var$directiveOrder.indexOf(a.type) === -1 ? $f347e48613385d9c$var$DEFAULT : a.type;
    let typeB = $f347e48613385d9c$var$directiveOrder.indexOf(b.type) === -1 ? $f347e48613385d9c$var$DEFAULT : b.type;
    return $f347e48613385d9c$var$directiveOrder.indexOf(typeA) - $f347e48613385d9c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $f347e48613385d9c$var$tickStack = [];
var $f347e48613385d9c$var$isHolding = false;
function $f347e48613385d9c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f347e48613385d9c$var$isHolding || setTimeout(()=>{
            $f347e48613385d9c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f347e48613385d9c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f347e48613385d9c$var$releaseNextTicks() {
    $f347e48613385d9c$var$isHolding = false;
    while($f347e48613385d9c$var$tickStack.length)$f347e48613385d9c$var$tickStack.shift()();
}
function $f347e48613385d9c$var$holdNextTicks() {
    $f347e48613385d9c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f347e48613385d9c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f347e48613385d9c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f347e48613385d9c$var$setClasses(el, value());
    return $f347e48613385d9c$var$setClassesFromString(el, value);
}
function $f347e48613385d9c$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f347e48613385d9c$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f347e48613385d9c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setStylesFromObject(el, value);
    return $f347e48613385d9c$var$setStylesFromString(el, value);
}
function $f347e48613385d9c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f347e48613385d9c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f347e48613385d9c$var$setStyles(el, previousStyles);
    };
}
function $f347e48613385d9c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f347e48613385d9c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f347e48613385d9c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f347e48613385d9c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f347e48613385d9c$var$registerTransitionsFromClassString(el, expression, value);
});
function $f347e48613385d9c$var$registerTransitionsFromClassString(el, classString, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f347e48613385d9c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f347e48613385d9c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f347e48613385d9c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f347e48613385d9c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f347e48613385d9c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f347e48613385d9c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f347e48613385d9c$var$closestHide(parent);
}
function $f347e48613385d9c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f347e48613385d9c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f347e48613385d9c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f347e48613385d9c$var$once(()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f347e48613385d9c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f347e48613385d9c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f347e48613385d9c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f347e48613385d9c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f347e48613385d9c$var$mutateDom(()=>{
                stages.end();
            });
            $f347e48613385d9c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f347e48613385d9c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f347e48613385d9c$var$isCloning = false;
function $f347e48613385d9c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f347e48613385d9c$var$isCloning ? fallback(...args) : callback(...args);
}
function $f347e48613385d9c$var$onlyDuringClone(callback) {
    return (...args)=>$f347e48613385d9c$var$isCloning && callback(...args);
}
var $f347e48613385d9c$var$interceptors = [];
function $f347e48613385d9c$var$interceptClone(callback) {
    $f347e48613385d9c$var$interceptors.push(callback);
}
function $f347e48613385d9c$var$cloneNode(from, to) {
    $f347e48613385d9c$var$interceptors.forEach((i)=>i(from, to));
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $f347e48613385d9c$var$isCloning = false;
}
var $f347e48613385d9c$var$isCloningLegacy = false;
function $f347e48613385d9c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$isCloningLegacy = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$cloneTree(newEl);
    });
    $f347e48613385d9c$var$isCloning = false;
    $f347e48613385d9c$var$isCloningLegacy = false;
}
function $f347e48613385d9c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f347e48613385d9c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f347e48613385d9c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f347e48613385d9c$var$initTree(el, shallowWalker);
}
function $f347e48613385d9c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f347e48613385d9c$var$effect;
    $f347e48613385d9c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f347e48613385d9c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f347e48613385d9c$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $f347e48613385d9c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f347e48613385d9c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f347e48613385d9c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f347e48613385d9c$var$bindInputValue(el, value);
            break;
        case "style":
            $f347e48613385d9c$var$bindStyles(el, value);
            break;
        case "class":
            $f347e48613385d9c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f347e48613385d9c$var$bindAttribute(el, name, value);
            break;
    }
}
function $f347e48613385d9c$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $f347e48613385d9c$var$safeParseBoolean(el.value) === value;
            else el.checked = $f347e48613385d9c$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f347e48613385d9c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f347e48613385d9c$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $f347e48613385d9c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f347e48613385d9c$var$setClasses(el, value);
}
function $f347e48613385d9c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f347e48613385d9c$var$setStyles(el, value);
}
function $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value) {
    $f347e48613385d9c$var$bindAttribute(el, name, value);
    $f347e48613385d9c$var$setPropertyIfChanged(el, name, value);
}
function $f347e48613385d9c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f347e48613385d9c$var$isBooleanAttr(name)) value = name;
        $f347e48613385d9c$var$setIfChanged(el, name, value);
    }
}
function $f347e48613385d9c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f347e48613385d9c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f347e48613385d9c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f347e48613385d9c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $f347e48613385d9c$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f347e48613385d9c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f347e48613385d9c$var$dontAutoEvaluateFunctions(()=>{
            return $f347e48613385d9c$var$evaluate(el, binding.expression);
        });
    }
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f347e48613385d9c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $f347e48613385d9c$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f347e48613385d9c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $f347e48613385d9c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $f347e48613385d9c$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($f347e48613385d9c$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $f347e48613385d9c$var$release(reference);
    };
}
function $f347e48613385d9c$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $f347e48613385d9c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f347e48613385d9c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f347e48613385d9c$var$stores = {};
var $f347e48613385d9c$var$isReactive = false;
function $f347e48613385d9c$var$store(name, value) {
    if (!$f347e48613385d9c$var$isReactive) {
        $f347e48613385d9c$var$stores = $f347e48613385d9c$var$reactive($f347e48613385d9c$var$stores);
        $f347e48613385d9c$var$isReactive = true;
    }
    if (value === void 0) return $f347e48613385d9c$var$stores[name];
    $f347e48613385d9c$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f347e48613385d9c$var$stores[name].init();
    $f347e48613385d9c$var$initInterceptors2($f347e48613385d9c$var$stores[name]);
}
function $f347e48613385d9c$var$getStores() {
    return $f347e48613385d9c$var$stores;
}
// packages/alpinejs/src/binds.js
var $f347e48613385d9c$var$binds = {};
function $f347e48613385d9c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $f347e48613385d9c$var$applyBindingsObject(name, getBindings());
    else $f347e48613385d9c$var$binds[name] = getBindings;
    return ()=>{};
}
function $f347e48613385d9c$var$injectBindingProviders(obj) {
    Object.entries($f347e48613385d9c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f347e48613385d9c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f347e48613385d9c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f347e48613385d9c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $f347e48613385d9c$var$datas = {};
function $f347e48613385d9c$var$data(name, callback) {
    $f347e48613385d9c$var$datas[name] = callback;
}
function $f347e48613385d9c$var$injectDataProviders(obj, context) {
    Object.entries($f347e48613385d9c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f347e48613385d9c$var$Alpine = {
    get reactive () {
        return $f347e48613385d9c$var$reactive;
    },
    get release () {
        return $f347e48613385d9c$var$release;
    },
    get effect () {
        return $f347e48613385d9c$var$effect;
    },
    get raw () {
        return $f347e48613385d9c$var$raw;
    },
    version: "3.13.5",
    flushAndStopDeferringMutations: $f347e48613385d9c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f347e48613385d9c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f347e48613385d9c$var$disableEffectScheduling,
    startObservingMutations: $f347e48613385d9c$var$startObservingMutations,
    stopObservingMutations: $f347e48613385d9c$var$stopObservingMutations,
    setReactivityEngine: $f347e48613385d9c$var$setReactivityEngine,
    onAttributeRemoved: $f347e48613385d9c$var$onAttributeRemoved,
    onAttributesAdded: $f347e48613385d9c$var$onAttributesAdded,
    closestDataStack: $f347e48613385d9c$var$closestDataStack,
    skipDuringClone: $f347e48613385d9c$var$skipDuringClone,
    onlyDuringClone: $f347e48613385d9c$var$onlyDuringClone,
    addRootSelector: $f347e48613385d9c$var$addRootSelector,
    addInitSelector: $f347e48613385d9c$var$addInitSelector,
    interceptClone: $f347e48613385d9c$var$interceptClone,
    addScopeToNode: $f347e48613385d9c$var$addScopeToNode,
    deferMutations: $f347e48613385d9c$var$deferMutations,
    mapAttributes: $f347e48613385d9c$var$mapAttributes,
    evaluateLater: $f347e48613385d9c$var$evaluateLater,
    interceptInit: $f347e48613385d9c$var$interceptInit,
    setEvaluator: $f347e48613385d9c$var$setEvaluator,
    mergeProxies: $f347e48613385d9c$var$mergeProxies,
    extractProp: $f347e48613385d9c$var$extractProp,
    findClosest: $f347e48613385d9c$var$findClosest,
    onElRemoved: $f347e48613385d9c$var$onElRemoved,
    closestRoot: $f347e48613385d9c$var$closestRoot,
    destroyTree: $f347e48613385d9c$var$destroyTree,
    interceptor: $f347e48613385d9c$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $f347e48613385d9c$var$transition,
    setStyles: // INTERNAL
    $f347e48613385d9c$var$setStyles,
    mutateDom: // INTERNAL
    $f347e48613385d9c$var$mutateDom,
    directive: $f347e48613385d9c$var$directive,
    entangle: $f347e48613385d9c$var$entangle,
    throttle: $f347e48613385d9c$var$throttle,
    debounce: $f347e48613385d9c$var$debounce,
    evaluate: $f347e48613385d9c$var$evaluate,
    initTree: $f347e48613385d9c$var$initTree,
    nextTick: $f347e48613385d9c$var$nextTick,
    prefixed: $f347e48613385d9c$var$prefix,
    prefix: $f347e48613385d9c$var$setPrefix,
    plugin: $f347e48613385d9c$var$plugin,
    magic: $f347e48613385d9c$var$magic,
    store: $f347e48613385d9c$var$store,
    start: $f347e48613385d9c$var$start,
    clone: $f347e48613385d9c$var$clone,
    cloneNode: // INTERNAL
    $f347e48613385d9c$var$cloneNode,
    // INTERNAL
    bound: $f347e48613385d9c$var$getBinding,
    $data: $f347e48613385d9c$var$scope,
    watch: $f347e48613385d9c$var$watch,
    walk: $f347e48613385d9c$var$walk,
    data: $f347e48613385d9c$var$data,
    bind: $f347e48613385d9c$var$bind2
};
var $f347e48613385d9c$var$alpine_default = $f347e48613385d9c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f347e48613385d9c$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f347e48613385d9c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f347e48613385d9c$var$isBooleanAttr2 = /* @__PURE__ */ $f347e48613385d9c$var$makeMap($f347e48613385d9c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f347e48613385d9c$var$EMPTY_OBJ = Object.freeze({});
var $f347e48613385d9c$var$EMPTY_ARR = Object.freeze([]);
var $f347e48613385d9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f347e48613385d9c$var$hasOwn = (val, key)=>$f347e48613385d9c$var$hasOwnProperty.call(val, key);
var $f347e48613385d9c$var$isArray = Array.isArray;
var $f347e48613385d9c$var$isMap = (val)=>$f347e48613385d9c$var$toTypeString(val) === "[object Map]";
var $f347e48613385d9c$var$isString = (val)=>typeof val === "string";
var $f347e48613385d9c$var$isSymbol = (val)=>typeof val === "symbol";
var $f347e48613385d9c$var$isObject = (val)=>val !== null && typeof val === "object";
var $f347e48613385d9c$var$objectToString = Object.prototype.toString;
var $f347e48613385d9c$var$toTypeString = (value)=>$f347e48613385d9c$var$objectToString.call(value);
var $f347e48613385d9c$var$toRawType = (value)=>{
    return $f347e48613385d9c$var$toTypeString(value).slice(8, -1);
};
var $f347e48613385d9c$var$isIntegerKey = (key)=>$f347e48613385d9c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f347e48613385d9c$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f347e48613385d9c$var$camelizeRE = /-(\w)/g;
var $f347e48613385d9c$var$camelize = $f347e48613385d9c$var$cacheStringFunction((str)=>{
    return str.replace($f347e48613385d9c$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f347e48613385d9c$var$hyphenateRE = /\B([A-Z])/g;
var $f347e48613385d9c$var$hyphenate = $f347e48613385d9c$var$cacheStringFunction((str)=>str.replace($f347e48613385d9c$var$hyphenateRE, "-$1").toLowerCase());
var $f347e48613385d9c$var$capitalize = $f347e48613385d9c$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f347e48613385d9c$var$toHandlerKey = $f347e48613385d9c$var$cacheStringFunction((str)=>str ? `on${$f347e48613385d9c$var$capitalize(str)}` : ``);
var $f347e48613385d9c$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f347e48613385d9c$var$targetMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$effectStack = [];
var $f347e48613385d9c$var$activeEffect;
var $f347e48613385d9c$var$ITERATE_KEY = Symbol("iterate");
var $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f347e48613385d9c$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f347e48613385d9c$var$effect2(fn, options = $f347e48613385d9c$var$EMPTY_OBJ) {
    if ($f347e48613385d9c$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f347e48613385d9c$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f347e48613385d9c$var$stop(effect3) {
    if (effect3.active) {
        $f347e48613385d9c$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f347e48613385d9c$var$uid = 0;
function $f347e48613385d9c$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f347e48613385d9c$var$effectStack.includes(effect3)) {
            $f347e48613385d9c$var$cleanup(effect3);
            try {
                $f347e48613385d9c$var$enableTracking();
                $f347e48613385d9c$var$effectStack.push(effect3);
                $f347e48613385d9c$var$activeEffect = effect3;
                return fn();
            } finally{
                $f347e48613385d9c$var$effectStack.pop();
                $f347e48613385d9c$var$resetTracking();
                $f347e48613385d9c$var$activeEffect = $f347e48613385d9c$var$effectStack[$f347e48613385d9c$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f347e48613385d9c$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f347e48613385d9c$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f347e48613385d9c$var$shouldTrack = true;
var $f347e48613385d9c$var$trackStack = [];
function $f347e48613385d9c$var$pauseTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = false;
}
function $f347e48613385d9c$var$enableTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = true;
}
function $f347e48613385d9c$var$resetTracking() {
    const last = $f347e48613385d9c$var$trackStack.pop();
    $f347e48613385d9c$var$shouldTrack = last === void 0 ? true : last;
}
function $f347e48613385d9c$var$track(target, type, key) {
    if (!$f347e48613385d9c$var$shouldTrack || $f347e48613385d9c$var$activeEffect === void 0) return;
    let depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) $f347e48613385d9c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($f347e48613385d9c$var$activeEffect)) {
        dep.add($f347e48613385d9c$var$activeEffect);
        $f347e48613385d9c$var$activeEffect.deps.push(dep);
        if ($f347e48613385d9c$var$activeEffect.options.onTrack) $f347e48613385d9c$var$activeEffect.options.onTrack({
            effect: $f347e48613385d9c$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f347e48613385d9c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f347e48613385d9c$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f347e48613385d9c$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                } else if ($f347e48613385d9c$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f347e48613385d9c$var$isNonTrackableKeys = /* @__PURE__ */ $f347e48613385d9c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f347e48613385d9c$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f347e48613385d9c$var$isSymbol));
var $f347e48613385d9c$var$get2 = /* @__PURE__ */ $f347e48613385d9c$var$createGetter();
var $f347e48613385d9c$var$readonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true);
var $f347e48613385d9c$var$arrayInstrumentations = /* @__PURE__ */ $f347e48613385d9c$var$createArrayInstrumentations();
function $f347e48613385d9c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $f347e48613385d9c$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$f347e48613385d9c$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($f347e48613385d9c$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $f347e48613385d9c$var$pauseTracking();
            const res = $f347e48613385d9c$var$toRaw(this)[key].apply(this, args);
            $f347e48613385d9c$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $f347e48613385d9c$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f347e48613385d9c$var$shallowReadonlyMap : $f347e48613385d9c$var$readonlyMap : shallow ? $f347e48613385d9c$var$shallowReactiveMap : $f347e48613385d9c$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f347e48613385d9c$var$isArray(target);
        if (!isReadonly && targetIsArray && $f347e48613385d9c$var$hasOwn($f347e48613385d9c$var$arrayInstrumentations, key)) return Reflect.get($f347e48613385d9c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f347e48613385d9c$var$isSymbol(key) ? $f347e48613385d9c$var$builtInSymbols.has(key) : $f347e48613385d9c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f347e48613385d9c$var$track(target, "get", key);
        if (shallow) return res;
        if ($f347e48613385d9c$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f347e48613385d9c$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f347e48613385d9c$var$isObject(res)) return isReadonly ? $f347e48613385d9c$var$readonly(res) : $f347e48613385d9c$var$reactive2(res);
        return res;
    };
}
var $f347e48613385d9c$var$set2 = /* @__PURE__ */ $f347e48613385d9c$var$createSetter();
function $f347e48613385d9c$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f347e48613385d9c$var$toRaw(value);
            oldValue = $f347e48613385d9c$var$toRaw(oldValue);
            if (!$f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isRef(oldValue) && !$f347e48613385d9c$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isIntegerKey(key) ? Number(key) < target.length : $f347e48613385d9c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f347e48613385d9c$var$toRaw(receiver)) {
            if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
            else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f347e48613385d9c$var$deleteProperty(target, key) {
    const hadKey = $f347e48613385d9c$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f347e48613385d9c$var$isSymbol(key) || !$f347e48613385d9c$var$builtInSymbols.has(key)) $f347e48613385d9c$var$track(target, "has", key);
    return result;
}
function $f347e48613385d9c$var$ownKeys(target) {
    $f347e48613385d9c$var$track(target, "iterate", $f347e48613385d9c$var$isArray(target) ? "length" : $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f347e48613385d9c$var$mutableHandlers = {
    get: $f347e48613385d9c$var$get2,
    set: $f347e48613385d9c$var$set2,
    deleteProperty: $f347e48613385d9c$var$deleteProperty,
    has: $f347e48613385d9c$var$has,
    ownKeys: $f347e48613385d9c$var$ownKeys
};
var $f347e48613385d9c$var$readonlyHandlers = {
    get: $f347e48613385d9c$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f347e48613385d9c$var$toReactive = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$reactive2(value) : value;
var $f347e48613385d9c$var$toReadonly = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$readonly(value) : value;
var $f347e48613385d9c$var$toShallow = (value)=>value;
var $f347e48613385d9c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f347e48613385d9c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f347e48613385d9c$var$getProto(rawTarget);
    const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f347e48613385d9c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f347e48613385d9c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f347e48613385d9c$var$track($f347e48613385d9c$var$toRaw(target), "iterate", $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f347e48613385d9c$var$add(value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const proto = $f347e48613385d9c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f347e48613385d9c$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f347e48613385d9c$var$set$1(key, value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
    else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f347e48613385d9c$var$deleteEntry(key) {
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$clear() {
    const target = $f347e48613385d9c$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f347e48613385d9c$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f347e48613385d9c$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f347e48613385d9c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", $f347e48613385d9c$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f347e48613385d9c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const targetIsMap = $f347e48613385d9c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", isKeyOnly ? $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY : $f347e48613385d9c$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f347e48613385d9c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f347e48613385d9c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f347e48613385d9c$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $f347e48613385d9c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, false, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$f347e48613385d9c$var$mutableInstrumentations, $f347e48613385d9c$var$readonlyInstrumentations, $f347e48613385d9c$var$shallowInstrumentations, $f347e48613385d9c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentations();
function $f347e48613385d9c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f347e48613385d9c$var$shallowReadonlyInstrumentations : $f347e48613385d9c$var$shallowInstrumentations : isReadonly ? $f347e48613385d9c$var$readonlyInstrumentations : $f347e48613385d9c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f347e48613385d9c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f347e48613385d9c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(false, false)
};
var $f347e48613385d9c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(true, false)
};
function $f347e48613385d9c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f347e48613385d9c$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f347e48613385d9c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $f347e48613385d9c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f347e48613385d9c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f347e48613385d9c$var$targetTypeMap($f347e48613385d9c$var$toRawType(value));
}
function $f347e48613385d9c$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f347e48613385d9c$var$createReactiveObject(target, false, $f347e48613385d9c$var$mutableHandlers, $f347e48613385d9c$var$mutableCollectionHandlers, $f347e48613385d9c$var$reactiveMap);
}
function $f347e48613385d9c$var$readonly(target) {
    return $f347e48613385d9c$var$createReactiveObject(target, true, $f347e48613385d9c$var$readonlyHandlers, $f347e48613385d9c$var$readonlyCollectionHandlers, $f347e48613385d9c$var$readonlyMap);
}
function $f347e48613385d9c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f347e48613385d9c$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f347e48613385d9c$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f347e48613385d9c$var$toRaw(observed) {
    return observed && $f347e48613385d9c$var$toRaw(observed["__v_raw"]) || observed;
}
function $f347e48613385d9c$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f347e48613385d9c$var$magic("nextTick", ()=>$f347e48613385d9c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f347e48613385d9c$var$magic("dispatch", (el)=>$f347e48613385d9c$var$dispatch.bind($f347e48613385d9c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f347e48613385d9c$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $f347e48613385d9c$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$f347e48613385d9c$var$magic("store", $f347e48613385d9c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f347e48613385d9c$var$magic("data", (el)=>$f347e48613385d9c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f347e48613385d9c$var$magic("root", (el)=>$f347e48613385d9c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f347e48613385d9c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f347e48613385d9c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f347e48613385d9c$var$globalIdMemo = {};
function $f347e48613385d9c$var$findAndIncrementId(name) {
    if (!$f347e48613385d9c$var$globalIdMemo[name]) $f347e48613385d9c$var$globalIdMemo[name] = 0;
    return ++$f347e48613385d9c$var$globalIdMemo[name];
}
function $f347e48613385d9c$var$closestIdRoot(el, name) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f347e48613385d9c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f347e48613385d9c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f347e48613385d9c$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $f347e48613385d9c$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $f347e48613385d9c$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$f347e48613385d9c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f347e48613385d9c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f347e48613385d9c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f347e48613385d9c$var$warnMissingPluginMagic(name, magicName, slug) {
    $f347e48613385d9c$var$magic(magicName, (el)=>$f347e48613385d9c$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$f347e48613385d9c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f347e48613385d9c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$f347e48613385d9c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f347e48613385d9c$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $f347e48613385d9c$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $f347e48613385d9c$var$getTarget(expression);
        $f347e48613385d9c$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $f347e48613385d9c$var$teleportContainerDuringClone = document.createElement("div");
function $f347e48613385d9c$var$getTarget(expression) {
    let target = $f347e48613385d9c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f347e48613385d9c$var$teleportContainerDuringClone;
    })();
    if (!target) $f347e48613385d9c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $f347e48613385d9c$var$handler = ()=>{};
$f347e48613385d9c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f347e48613385d9c$var$directive("ignore", $f347e48613385d9c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f347e48613385d9c$var$directive("effect", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($f347e48613385d9c$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $f347e48613385d9c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f347e48613385d9c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f347e48613385d9c$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f347e48613385d9c$var$isKeyEvent(event)) {
            if ($f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f347e48613385d9c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f347e48613385d9c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f347e48613385d9c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f347e48613385d9c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f347e48613385d9c$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f347e48613385d9c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f347e48613385d9c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f347e48613385d9c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f347e48613385d9c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f347e48613385d9c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f347e48613385d9c$var$isCloning ? ()=>{} : $f347e48613385d9c$var$on(el, event, modifiers, (e)=>{
        setValue($f347e48613385d9c$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f347e48613385d9c$var$on(el.form, "reset", [], (e)=>{
            $f347e48613385d9c$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f347e48613385d9c$var$getInputValue(el, modifiers, event, currentValue) {
    return $f347e48613385d9c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $f347e48613385d9c$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $f347e48613385d9c$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f347e48613385d9c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            if (modifiers.includes("number")) return $f347e48613385d9c$var$safeParseNumber(event.target.value);
            else if (modifiers.includes("boolean")) return $f347e48613385d9c$var$safeParseBoolean(event.target.value);
            return modifiers.includes("trim") ? event.target.value.trim() : event.target.value;
        }
    });
}
function $f347e48613385d9c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f347e48613385d9c$var$isNumeric2(number) ? number : rawValue;
}
function $f347e48613385d9c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f347e48613385d9c$var$directive("cloak", (el)=>queueMicrotask(()=>$f347e48613385d9c$var$mutateDom(()=>el.removeAttribute($f347e48613385d9c$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f347e48613385d9c$var$addInitSelector(()=>`[${$f347e48613385d9c$var$prefix("init")}]`);
$f347e48613385d9c$var$directive("init", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f347e48613385d9c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f347e48613385d9c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f347e48613385d9c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith(":", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("bind:"))));
var $f347e48613385d9c$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $f347e48613385d9c$var$injectBindingProviders(bindingProviders);
        let getBindings = $f347e48613385d9c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f347e48613385d9c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f347e48613385d9c$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, value, result, modifiers));
        }));
};
$f347e48613385d9c$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f347e48613385d9c$var$directive("bind", $f347e48613385d9c$var$handler2);
function $f347e48613385d9c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f347e48613385d9c$var$addRootSelector(()=>`[${$f347e48613385d9c$var$prefix("data")}]`);
$f347e48613385d9c$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f347e48613385d9c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f347e48613385d9c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f347e48613385d9c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f347e48613385d9c$var$injectMagics(data2, el);
    let reactiveData = $f347e48613385d9c$var$reactive(data2);
    $f347e48613385d9c$var$initInterceptors2(reactiveData);
    let undo = $f347e48613385d9c$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f347e48613385d9c$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f347e48613385d9c$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$f347e48613385d9c$var$isCloning) return false;
    if ($f347e48613385d9c$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$f347e48613385d9c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f347e48613385d9c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f347e48613385d9c$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f347e48613385d9c$var$parseForExpression(expression);
    let evaluateItems = $f347e48613385d9c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f347e48613385d9c$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f347e48613385d9c$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($f347e48613385d9c$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f347e48613385d9c$var$mutateDom(()=>{
                if (!elForSpot) $f347e48613385d9c$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f347e48613385d9c$var$reactive(scope2);
            $f347e48613385d9c$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f347e48613385d9c$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f347e48613385d9c$var$initTree(clone2);
            });
            if (typeof key === "object") $f347e48613385d9c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f347e48613385d9c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f347e48613385d9c$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f347e48613385d9c$var$handler3() {}
$f347e48613385d9c$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f347e48613385d9c$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f347e48613385d9c$var$directive("ref", $f347e48613385d9c$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f347e48613385d9c$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
        $f347e48613385d9c$var$mutateDom(()=>{
            el.after(clone2);
            $f347e48613385d9c$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f347e48613385d9c$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($f347e48613385d9c$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f347e48613385d9c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f347e48613385d9c$var$setIdRoot(el, name));
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith("@", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("on:"))));
$f347e48613385d9c$var$directive("on", $f347e48613385d9c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f347e48613385d9c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f347e48613385d9c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f347e48613385d9c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f347e48613385d9c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f347e48613385d9c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f347e48613385d9c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f347e48613385d9c$var$warnMissingPluginDirective(name, directiveName, slug) {
    $f347e48613385d9c$var$directive(directiveName, (el)=>$f347e48613385d9c$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f347e48613385d9c$var$alpine_default.setEvaluator($f347e48613385d9c$var$normalEvaluator);
$f347e48613385d9c$var$alpine_default.setReactivityEngine({
    reactive: $f347e48613385d9c$var$reactive2,
    effect: $f347e48613385d9c$var$effect2,
    release: $f347e48613385d9c$var$stop,
    raw: $f347e48613385d9c$var$toRaw
});
var $f347e48613385d9c$export$b7ee041e4ad2afec = $f347e48613385d9c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f347e48613385d9c$export$2e2bcd8739ae039 = $f347e48613385d9c$export$b7ee041e4ad2afec;


(function() {
    var initMultipass = function(res) {
        return function() {
            let data = {
                id: res.UID,
                email: res.profile.email,
                firstName: res.profile.firstName,
                lastName: res.profile.lastName,
                returnMultipassToken: true
            };
            const url = window.location.href;
            const urlObj = new URL(url);
            const returnUrl = urlObj.searchParams.get("return_url");
            const decodedReturnUrl = decodeURIComponent(returnUrl);
            if (decodedReturnUrl !== null && urlObj.hash) window.loginReturnTo = returnUrl + urlObj.hash;
            if (window.loginReturnTo) data.returnTo = window.loginReturnTo;
            $.ajax({
                method: "POST",
                url: window.akc.services.multipassUrl,
                contentType: "application/json",
                data: JSON.stringify(data),
                success: function(data) {
                    window.localStorage.setItem("multipassToken", data.token);
                    window.localStorage.removeItem("customerAccessToken");
                    window.localStorage.removeItem("customerAccessTokenExpiresAt");
                    window.location.href = data.authUrl;
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error(textStatus, errorThrown);
                }
            });
        };
    };
    const initRecaptcha = (action, callback = null)=>{
        return new Promise((resolve, reject)=>{
            window.grecaptcha.ready(()=>{
                window.grecaptcha.execute(window.akc.recaptcha.siteKey, {
                    action: action
                }).then((token)=>{
                    if (callback) callback(token).then((result)=>{
                        resolve(result);
                    }).catch((error)=>{
                        reject(error);
                    });
                }).catch((error)=>{
                    reject(error);
                });
            });
        });
    };
    const verify = async (token)=>{
        try {
            let isBot = false;
            const response = await fetch(window.akc.services.recaptchaUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    token: token
                })
            });
            const data = await response.json();
            if (data.siteVerifyResponse.score <= window.akc.recaptcha.threshold) isBot = true;
            return isBot;
        } catch (error) {
            throw error;
        }
    };
    const checkBot = async (event)=>{
        let action;
        if (event.form === "gigya-register-form") action = "sign_up";
        else if (event.form === "gigya-login-form") action = "sign_in";
        let isBot = await initRecaptcha(action, verify);
        let errors = {
            sign_in: {
                "form": "Bot detected: prevent sign in"
            },
            sign_up: {
                "form": "Bot detected: prevent sign up"
            }
        };
        if (isBot) return errors[action];
    };
    gigya.accounts.addEventHandlers({
        onLogin: function(res) {
            var multipass = initMultipass(res);
            if (res.data.enableTFA === "true" || res.data.enableTFA === "false") multipass();
            else {
                window.onTFAflowComplete = function() {};
                gigya.accounts.showScreenSet({
                    screenSet: "tfaRegistrationLogin",
                    startScreen: "gigya-complete-registration-screen",
                    onHide: function() {
                        multipass();
                    }
                });
            }
        },
        onLogout: function() {
            window.location.href = window.akc.routes.accountLogoutUrl;
        }
    });
    window.akc.getRegisterScreenset = function(options) {
        window.loginReturnTo = options?.returnTo || window.location.href;
        window.gigya.accounts.showScreenSet({
            screenSet: "Login-web-2",
            startScreen: "gigya-register-screen",
            mobileScreenSet: "Login-web-2",
            onBeforeValidation: (e)=>checkBot(e)
        });
    };
    window.akc.getLoginScreenset = function(options) {
        window.loginReturnTo = options?.returnTo || window.location.href;
        window.gigya.accounts.showScreenSet({
            screenSet: "Login-web-2",
            startScreen: "gigya-login-screen",
            mobileScreenSet: "Login-web-2",
            onBeforeValidation: (e)=>checkBot(e)
        });
        if (window.location.pathname === window.akc.routes.cartUrl) window.loginReturnTo = window.akc.routes.cartUrl;
    };
    window.akc.getLogoutScreenset = function() {
        window.localStorage.removeItem("multipassToken");
        window.localStorage.removeItem("customerAccessToken");
        window.localStorage.removeItem("customerAccessTokenExpiresAt");
        window.gigya.accounts.logout();
    };
})();


window.customElements.define("quantity-selector", class QuantitySelector extends HTMLElement {
    constructor(){
        super();
        this.updateDiscountPrices();
        this.input = this.querySelector('input[type="number"]');
        this.minusButton = this.querySelector('button[name="minus"]');
        this.minValue = parseInt(this.input.min);
        this.changeEvent = new Event("change", {
            bubbles: true
        });
        this.input.addEventListener("change", this.onValueChange.bind(this));
        this.input.addEventListener("keyup", this.onValueChange.bind(this));
        this.querySelectorAll("button").forEach((button)=>button.addEventListener("click", this.onButtonClick.bind(this)));
    }
    onValueChange(event) {
        if (this.input.value > this.minValue) this.minusButton.removeAttribute("disabled");
        else this.minusButton.setAttribute("disabled", "disabled");
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        let currentButton = event.target.closest(".quantity-selector__button");
        currentButton.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        // Continue dispatch if there was an actual change
        if (previousValue !== this.input.value) {
            this.input.dispatchEvent(this.changeEvent);
            this.updateDiscountPrices();
        }
    }
    updateDiscountPrices() {
        let allocatedAmountSummaryLine = 0;
        $(".cart-item-item").each(function() {
            let allocatedAmount = 0;
            const quantity = parseFloat($(this).find(".input-quantity").val());
            const originalPriceElement = $(this).find(".item-original-price");
            const priceText = originalPriceElement.text();
            if (priceText === "") return;
            const price = parseFloat(priceText.replace(/[^0-9.-]+/g, ""));
            allocatedAmount = quantity * price;
            $(this).find(".total-original-allocated-amount").text("$" + allocatedAmount.toFixed(2));
            allocatedAmountSummaryLine = allocatedAmount;
        });
        $(".total-allocated-amount").text("$" + allocatedAmountSummaryLine.toFixed(2));
    }
});
window.customElements.define("variant-picker", class VariantPicker extends HTMLElement {
    constructor(){
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("click", this.onSwatchClick);
        document.addEventListener("DOMContentLoaded", ()=>{
            const firstSwatch = document.querySelector(".swatch");
            if (firstSwatch) firstSwatch.click();
            const variantPicker = document.getElementById("product__main__variant-picker");
            if (variantPicker) {
                const selectElement = variantPicker.querySelector("select");
                if (selectElement) {
                    this.updateOptions(); // Ensure options are set
                    this.updateCurrentVariant(); // Set currentVariant on load
                    if (this.currentVariant) {
                        this.updateURL();
                        this.updateVariantInput();
                        this.renderProductInfo();
                    } else this.setUnavailable();
                }
            }
        });
    }
    connectedCallback() {
        this.onVariantChange();
    }
    onVariantChange(evt) {
        // Product properties changes do not necessitate a full state update
        if (evt && evt.target.name.startsWith("properties[")) return;
        if (evt && evt.target.classList.contains("swatch")) return;
        this.updateOptions();
        this.updateCurrentVariant();
        this.toggleAddButton(true, true);
        this.removeErrorMessage();
        if (!this.currentVariant) {
            this.toggleAddButton();
            this.setUnavailable();
        } else {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
        this.dispatchEvent(new Event("variantchange"));
    }
    onSwatchClick(evt) {
        if (evt.target.classList.contains("swatch")) {
            const targetSwatchValue = evt.target.getAttribute("data-select");
            this.options = [
                targetSwatchValue
            ];
            this.updateCurrentVariant();
            this.highlightCurrentSwatch();
            this.toggleAddButton(true, true);
            this.removeErrorMessage();
            if (!this.currentVariant) {
                this.toggleAddButton();
                this.setUnavailable();
            } else {
                this.updateURL();
                this.updateVariantInput();
                this.renderProductInfo();
            }
            this.dispatchEvent(new Event("variantchange"));
        }
    }
    highlightCurrentSwatch() {
        const swatches = this.querySelectorAll(".swatch");
        swatches.forEach((swatch)=>{
            const value = swatch.dataset.value || swatch.textContent.trim();
            if (this.currentVariant.options.includes(value)) swatch.classList.add("active"); // Add an `active` class
            else swatch.classList.remove("active");
        });
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("fieldset, select"), (variantPicker)=>{
            return variantPicker.tagName === "FIELDSET" ? Array.from(variantPicker.querySelectorAll("input")).find((radio)=>radio.checked).value : variantPicker.value;
        });
    }
    updateCurrentVariant() {
        this.currentVariant = this.getVariantData().find((variant)=>{
            return variant.options.every((option, index)=>{
                return this.options[index] === option;
            });
        });
    }
    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        const currentUrl = new URL(window.location.href);
        const newUrl = new URL(this.dataset.url, window.location.origin);
        // merge all existing query parameters, including the UTM parameters
        currentUrl.searchParams.forEach((value, key)=>{
            newUrl.searchParams.set(key, value);
        });
        newUrl.searchParams.set("variant", this.currentVariant.id);
        // Update the browser URL without reloading the page
        window.history.replaceState({}, "", newUrl.toString());
    }
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm)=>{
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        });
    }
    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;
        const productForm = section.querySelector("product-form");
        if (productForm) {
            const successNotification = productForm.querySelector(".product-form__cart-notification");
            successNotification.classList.remove("product-form__cart-notification--show");
        }
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then((response)=>response.text()).then((responseText)=>{
            const id = `Price-${this.dataset.section}`;
            const html = new DOMParser().parseFromString(responseText, "text/html");
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            const price = document.getElementById(`Price-${this.dataset.section}`);
            if (price) price.classList.remove("visibility-hidden");
            this.toggleAddButton(!this.currentVariant.available);
        });
    }
    toggleAddButton(disable = true, loading = false) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        const templateSuffix = addButton.getAttribute("data-template-suffix");
        const signedIn = addButton.getAttribute("data-signed-in") === "true" ? true : false;
        if (!addButton) return;
        if (disable && loading) {
            addButton.setAttribute("disabled", "disabled");
            addButtonText.textContent = "Loading";
        } else if (disable) {
            addButton.setAttribute("disabled", "disabled");
            addButtonText.textContent = "Sold Out";
        } else if (templateSuffix === "must-login" && !signedIn) {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = "Login";
        } else if (templateSuffix === "must-login" && signedIn) {
            addButton.setAttribute("disabled", "disabled");
            addButtonText.textContent = "Add to Cart";
        } else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = "Add to Cart";
        }
    }
    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`Price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = "Unavailable";
        if (price) price.classList.add("visibility-hidden");
    }
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
});
window.customElements.define("file-uploader", class FileUploader extends HTMLElement {
    constructor(){
        super();
        this.input = this.querySelector('input[type="file"]');
        this.visualInput = this.querySelector(".product-form__input");
        this.instructions = this.querySelector(".product-form__instructions");
        this.visualInput.addEventListener("click", this.handleClick.bind(this));
        if (this.instructions) this.input.addEventListener("change", this.updateInstructions.bind(this));
    }
    handleClick(evt) {
        this.input.click();
    }
    updateInstructions(evt) {
        if (this.input.checkValidity()) this.instructions.textContent = evt.target.value.replace("C:\\fakepath\\", "");
        else this.instructions.textContent = "No file chosen";
    }
});
window.customElements.define("select-caret", class SelectCaret extends HTMLElement {
    constructor(){
        super();
        this.select = document.querySelector(`#${this.dataset.select}`);
        if (this.select) {
            this.select.addEventListener("click", this.onOpen.bind(this));
            this.select.addEventListener("mousedown", this.onOpen.bind(this));
            this.select.addEventListener("blur", this.onClose.bind(this));
            this.select.addEventListener("pointerleave", this.onClose.bind(this));
        }
    }
    onOpen(evt) {
        this.classList.add("product-form__select-caret--open");
    }
    onClose(evt) {
        this.classList.remove("product-form__select-caret--open");
    }
});
window.customElements.define("gift-note", class GiftNote extends HTMLElement {
    constructor(){
        super();
        this.formId = this.dataset.form;
        this.toggle = this.querySelector('input[name="gift-note-toggle"]');
        this.giftInputsWrapper = this.querySelector(".gift-note__panel");
        this.giftInputs = Array.from(this.querySelectorAll(".gift-note__panel input, .gift-note__panel textarea"));
        this.toggle.addEventListener("change", this.toggleInputs.bind(this));
    }
    toggleInputs(evt) {
        this.giftInputs.forEach((input)=>{
            if (evt.target.checked) {
                input.setAttribute("form", this.formId);
                this.giftInputsWrapper.classList.add("gift-note__panel--show");
            } else {
                input.removeAttribute("form");
                this.giftInputsWrapper.classList.remove("gift-note__panel--show");
            }
        });
    }
});
window.customElements.define("product-carousel", class ProductCarousel extends HTMLElement {
    constructor(){
        super();
        const config = {
            slidesPerView: 1.5,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                1024: {
                    slidesPerView: 3.5
                },
                1280: {
                    slidesPerView: 4.5
                }
            },
            pagination: {
                el: ".swiper-pagination"
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        };
        let swiper = new Swiper(this, config);
        if (Shopify.designMode) {
            document.addEventListener("shopify:section:load", (evt)=>{
                swiper = new Swiper(this, config);
            });
            document.addEventListener("shopify:section:unload", (evt)=>{
                swiper.destroy();
            });
        }
    }
});
window.customElements.define("recently-viewed-products", class RecentlyViewedProducts extends HTMLElement {
    constructor(){
        super();
        this.container = this.querySelector("section");
        this.swiperTemplate = this.querySelector("template.recently-viewed-products-swiper-template");
        this.slideTemplate = this.querySelector("template.recently-viewed-products-slide-template");
        this.productHandles = this.getRecentlyViewed();
        this.products = new Array(this.productHandles.length);
        this.init();
    }
    getRecentlyViewed() {
        const products = Cookies.get("recently-viewed-products");
        return products ? JSON.parse(products) : [];
    }
    async init() {
        await this.fetchProducts();
        this.render();
        this.addRecentlyViewed();
    }
    async fetchProducts() {
        if (!this.productHandles.length) return;
        let fetchPromises = this.productHandles.map(this.fetchProduct.bind(this));
        return Promise.all(fetchPromises);
    }
    async fetchProduct(productHandle, index) {
        try {
            let res = await fetch(`/products/${productHandle}.js`);
            res = await res.json();
            this.products.splice(index, 1, res);
        } catch (err) {
            console.error(err);
        }
    }
    render() {
        const swiperContainer = this.swiperTemplate.content.cloneNode(true);
        const slidesContainer = swiperContainer.querySelector(".swiper-wrapper");
        const badgeTags = [
            "Sale",
            "New Arrivals",
            "Best Seller"
        ];
        // Build section heading
        let heading = document.createElement("template");
        const headingDiv = `
      <div class="recently-viewed-products__product-carousel-heading">
        <h2>Recently Viewed</h2>
      </div>
    `;
        heading.innerHTML = headingDiv.trim();
        heading = heading.content;
        // Build product carousel
        this.products.forEach((product)=>{
            const slideContainer = this.slideTemplate.content.cloneNode(true);
            // Set Url
            const slideLink = slideContainer.querySelector(".card");
            slideLink.href = product.url;
            // Set Badge
            const slideBadge = slideContainer.querySelector(".card__badge");
            const badgeTag = product.tags.find((tag)=>badgeTags.includes(tag));
            if (badgeTag) {
                const badgeHandle = badgeTag.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
                slideBadge.classList.add(`card__badge--${badgeHandle}`);
                slideBadge.textContent = badgeTag;
            } else slideBadge.remove();
            // Set Image
            if (product.featured_image) {
                const imageUrl = new URL(product.featured_image, window.location.origin);
                const imageExtentionIndex = imageUrl.pathname.lastIndexOf(".");
                const image = document.createElement("img");
                imageUrl.pathname = `${imageUrl.pathname.slice(0, imageExtentionIndex)}_200x160${imageUrl.pathname.slice(imageExtentionIndex)}`;
                image.src = imageUrl.toString();
                slideContainer.querySelector(".card__image").appendChild(image);
            }
            // Set Title
            slideContainer.querySelector(".card__title").textContent = product.title;
            // Set Price
            const price = slideContainer.querySelector(".card__price");
            price.lastChild.textContent = Shopify.formatMoney(product.price);
            if (product.compare_at_price) price.querySelector(".card__compare-price").textContent = Shopify.formatMoney(product.compare_at_price);
            else price.querySelector(".card__compare-price-wrap").remove();
            // Set Button
            slideContainer.querySelector(".card__button button").dataset.product = product.handle;
            slidesContainer.appendChild(slideContainer);
        });
        // Render sections
        this.container.innerHTML = "";
        this.container.append(heading, swiperContainer);
    // Init quick views
    }
    addRecentlyViewed() {
        // Abort if we're not on a product page
        if (!window.location.pathname.includes("/products/")) return;
        let handles = this.productHandles;
        const currentHandle = window.location.pathname.substring(window.location.pathname.lastIndexOf("/products/") + 10);
        const productHasBeenRecentlyViewed = handles.some((handle)=>handle === currentHandle);
        // If the product is already on the list, remove it so we don't have duplicates
        if (productHasBeenRecentlyViewed) handles = handles.filter((handle)=>handle !== currentHandle);
        handles.unshift(currentHandle);
        if (handles.length > 5) handles.pop();
        this.productHandles = handles;
        Cookies.set("recently-viewed-products", JSON.stringify(this.productHandles));
    }
});


// -----------------------------------------------
// BECAUSE IE IS CACHING updateCartTotals CALL
// -----------------------------------------------

var $6Ny6s = parcelRequire("6Ny6s");
$.ajaxSetup({
    cache: false
});
// -----------------------------------------------
// SET REUSABLE VARIABLES
// -----------------------------------------------
const $7dad3bb78525ed3f$var$MONEY_FORMAT = "$ {{amount}}";
// -----------------------------------------------
// SET UP QUEUE FOR AJAX CALLS
// -----------------------------------------------
const $7dad3bb78525ed3f$var$Queue = ()=>{
    var previous = new $.Deferred().resolve();
    return (fn, fail)=>{
        return previous = previous.then(fn, fail || fn);
    };
};
const $7dad3bb78525ed3f$var$queue = $7dad3bb78525ed3f$var$Queue();
/**
 * Updates the cart totals in the header and cart page
 *
 * @param {function} callback - A callback function to run after the cart totals have been updated
 */ const $7dad3bb78525ed3f$var$updateCartTotals = (callback)=>{
    $7dad3bb78525ed3f$var$queue(()=>{
        // Get the cart
        $.get("/cart.js", ()=>{}, "json")// When we get the cart, update the cart totals
        .done((cart)=>{
            cart.item_count < 99 ? $(".nav-cart-count").text(cart.item_count) : $(".nav-cart-count").text("99+");
            cart.item_count < 2 ? $(".cart-items-pluralize").text("Item") : $(".cart-items-pluralize").text("Items");
            $(".cart-items-count").text(cart.item_count);
            $(".items-subtotal-price").html(Shopify.formatMoney(cart.total_price, $7dad3bb78525ed3f$var$MONEY_FORMAT));
            $(".cart-total").html(Shopify.formatMoney(cart.total_price, $7dad3bb78525ed3f$var$MONEY_FORMAT));
            // If we have a callback, call it with the cart
            if (callback) callback(cart);
        }).fail((response)=>{
            // If we fail, log an error
            console.error("Failed to update cart totals: ", response);
        });
    });
};
/**
 *
 * Updates the quantity of a specific line item in the shopping cart
 *
 * @param {number} lineItemKey - The key of the line item to update
 * @param {number} lineItemQuantity - The new quantity of the line item
 */ const $7dad3bb78525ed3f$var$updateCartLineItem = (lineItemKey, lineItemQuantity)=>{
    $7dad3bb78525ed3f$var$queue(()=>{
        $.post("/cart/change.js", {
            id: lineItemKey,
            quantity: lineItemQuantity
        }, (data)=>{
            // Success callback: This function is called when the post request succeeds.
            // It updates the line item price and discounts, and then updates the cart totals.
            const cart = data // Assuming the response is the cart data
            ;
            const $lineItems = $(".cart-item-item");
            // Update line item price and discounts
            $.each(cart.items, (i, lineItem)=>{
                const $lineItem = $($lineItems[i]);
                const $lineItemSinglePrice = $lineItem.find(".item-single-price");
                const $lineItemPrice = $lineItem.find(".item-line-price");
                // Update the line item price with the new value from the cart data
                $lineItemPrice.text(Shopify.formatMoney(lineItem.final_line_price, $7dad3bb78525ed3f$var$MONEY_FORMAT));
                // Show/hide the single item price based on the quantity
                lineItem.quantity <= 1 ? $lineItemSinglePrice.addClass("hide") : $lineItemSinglePrice.removeClass("hide");
                if (lineItem.discounts.length || lineItem.line_level_discount_allocations.length) {
                    const discountMessage = lineItem.discounts.map(function(discount) {
                        return discount.title;
                    }).join(", ");
                    // Show the discount message if there are discounts
                    const $discountSpan = $("<span>", {
                        text: " " + discountMessage + " "
                    });
                    $lineItem.find(".item-message").empty().append($discountSpan).show();
                    $lineItemPrice.addClass("discount");
                } else // Hide the discount message and remove the 'discount' class from the line item price
                $lineItem.find(".item-message").empty().hide();
            });
            // Update the cart totals
            $7dad3bb78525ed3f$var$updateCartTotals();
        }, "json").fail(function(response) {
            // Error callback: This function is called when the post request fails.
            console.error("Failed to update: ", response);
            alert("The quantity that you entered is not available. Please select a lower quantity to continue");
        });
    });
};
/**
 * Updates the quantity of a specific line item in the shopping cart
 *
 * @param {number} variantID - The ID of the variant to update
 * @param {number} quantity - The new quantity of the line item
 *
 */ const $7dad3bb78525ed3f$var$updateCartLineItemVariant = (lineItemKey, newVariantId, quantity, removeIndex)=>{
    (0, $6Ny6s.fetchCartData)().then((cart)=>{
        // find the index of the item
        const index = cart.items.findIndex((i)=>i.key === lineItemKey);
        // Handle the case where the index is not found
        if (index === -1) {
            console.error(`Item not found in the cart.`);
            alert("The item you are trying to update was not found in the cart.");
            return;
        }
        const item = cart.items[index];
        // get the value of the variant to check if engraving is selected
        const domItems = document.querySelectorAll(`[data-key="${lineItemKey}"]`);
        // Process engraving properties
        const { engravingSelected: engravingSelected, engravingLine1: engravingLine1, engravingLine2: engravingLine2, dogName: dogName } = $7dad3bb78525ed3f$var$processEngravingProperties(domItems, item.properties);
        // Merge engraving properties with existing properties
        const mergedProperties = $7dad3bb78525ed3f$var$mergeProperties(item.properties, engravingSelected, engravingLine1, engravingLine2, dogName);
        // Remove old line item
        return $7dad3bb78525ed3f$var$removeCartLineItem(removeIndex).then(()=>mergedProperties);
    }).then((mergedProperties)=>{
        // Add new line item with updated variant and properties
        return $.post("/cart/add.js", {
            id: newVariantId,
            quantity: quantity,
            properties: mergedProperties
        }, (data)=>{}, "json");
    }).then(()=>{
        // Successful AJAX request, update the cart totals
        $7dad3bb78525ed3f$var$updateCartTotals();
        // refresh page
        window.location.reload();
    }).catch((error)=>{
        // Failed AJAX request, log the error, message the user, and re-enable the inputs
        console.error("Failed to update: ", error);
        alert("The option you selected is not available, please pick a different option.");
    });
};
const $7dad3bb78525ed3f$var$processEngravingProperties = (domItems, itemProperties)=>{
    let engravingLine1 = "";
    let engravingLine2 = "";
    let dogName = "";
    let engravingSelected = false;
    // Iterate over domItems to process each element
    domItems.forEach((domItem)=>{
        if (domItem.tagName === "SELECT") // Handle <select> elements
        {
            if (domItem.value.toLowerCase().includes("engraving") || domItem.value.toLowerCase().includes("yes")) engravingSelected = true;
        } else if (domItem.tagName === "INPUT") {
            // Handle <input> elements
            if (domItem.name === "Engraving Line 1") engravingLine1 = domItem.value.trim();
            else if (domItem.name === "Engraving Line 2") engravingLine2 = domItem.value.trim();
            else if (domItem.name === "Dog Name") dogName = domItem.value.trim();
        }
    });
    // Fallback to existing properties if inputs are not found
    engravingLine1 = engravingLine1 || itemProperties?.["Engraving Line 1"] || "";
    engravingLine2 = engravingLine2 || itemProperties?.["Engraving Line 2"] || "";
    dogName = dogName || itemProperties?.["Dog Name"] || "";
    return {
        engravingSelected: engravingSelected,
        engravingLine1: engravingLine1,
        engravingLine2: engravingLine2,
        dogName: dogName
    };
};
const $7dad3bb78525ed3f$var$mergeProperties = (itemProperties, engravingSelected, engravingLine1, engravingLine2, dogName)=>{
    return {
        // Include all existing properties
        ...itemProperties,
        ...engravingSelected ? {
            // Add engraving properties if engraving is selected
            "Engraving Line 1": engravingLine1,
            "Engraving Line 2": engravingLine2,
            "Dog Name": dogName
        } : {
            // Remove engraving properties if engraving is not selected
            "Engraving Line 1": undefined,
            "Engraving Line 2": undefined,
            "Dog Name": undefined
        }
    };
};
/**
 * Removes a specific line item from the shopping cart
 *
 * @param {number} index - The index of the line item to remove
 */ const $7dad3bb78525ed3f$var$removeCartLineItem = (index)=>{
    // Return the result of the AJAX request
    return new Promise((resolve, reject)=>{
        // Send a POST request to the Shopify AJAX API to change the cart
        $.post("/cart/change.js", {
            // Set the quantity of the line item to 0, removing it from the cart
            quantity: 0,
            // Specify the line item to change using its index
            line: index
        }, // Empty success callback, as no action is taken with the returned data from the AJAX request
        ()=>{}, "json").done((cart)=>{
            // Resolve the promise with the cart data
            resolve(cart);
        }).fail((response)=>{
            // Reject the promise with an error
            reject(new Error("Failed to remove item"));
        });
    });
};
/**
 * Adds a product to the shopping cart.
 *
 * @param {jQuery} $btn - The add-to-cart button
 * @param {function} callback - A callback function to execute after the product is added
 */ const $7dad3bb78525ed3f$var$addToCart = ($btn, callback)=>{
    // Hide the add-to-cart button and quantity field, and show a spinner
    $btn.hide();
    $("#QtyArea").toggleClass("QtyAreaVisibilityToggle") // Preserve inline-block by using toggleClass instead of hide
    ;
    $('<div class="spinner-add-to-cart sk-spinner sk-spinner-pulse"></div>').insertAfter($btn);
    // Create a FormData object from the add-to-cart form
    const formData = new FormData($("#AddToCartForm")[0]);
    // Add the product to the cart
    $7dad3bb78525ed3f$var$queue(()=>{
        $.post({
            url: "/cart/add.js",
            contentType: false,
            processData: false,
            data: formData,
            dataType: "json"
        }).done(()=>{
            // If the request is successful, remove any existing checkout callouts and success messages
            $(".checkout-callout").remove();
            $(".added-success-message").remove();
            // Remove the spinner
            // $('.spinner-add-to-cart').remove()
            // Show a success message
            // if ($('.added-success-message').length < 1) {
            //     var $added_success = $("<p class='added-success-message'>Item successfully added to cart.</p>")
            //     $added_success.insertAfter($btn)
            // }
            // Show a checkout callout
            if ($(".checkout-callout").length < 1) {
                var $checkout_callout = $("<div class='checkout-callout'></div>");
                $checkout_callout.append("<p>Cart <span class='cart-items-count'></span> Items | <span class='cart-total'></span></p>");
                $checkout_callout.append("<a class='btn' href='/cart'>Checkout</a>");
                $checkout_callout.hide().insertAfter("#PriceQtyAdd");
            }
            // Update the cart totals
            $7dad3bb78525ed3f$var$updateCartTotals(()=>{
                $checkout_callout.show();
            });
            initCartSelectWidth();
            // Execute the callback function
            if (callback) callback();
            // After 3 seconds, clear the success message and show the add-to-cart button and quantity field again
            setTimeout(()=>{
                $added_success.fadeOut(400, ()=>{
                    $btn.fadeIn();
                    $("#QtyArea").fadeIn();
                    $("#QtyArea").toggleClass("QtyAreaVisibilityToggle");
                    $(undefined).closest("form").find("input[type=text], textarea").val("");
                    $(undefined).remove();
                });
            }, 3000);
        }).fail(()=>{
            // If the request fails, show an alert to the user, remove the spinner, and show the add-to-cart button and quantity field again
            alert("The quantity that you entered is not available. Please select a lower quantity to continue");
            $(".spinner-add-to-cart").remove();
            $btn.show();
            $("#QtyArea").toggleClass("QtyAreaVisibilityToggle") // Preserve inline-block by using toggleClass instead of hide.
            ;
        });
    });
};
/**
 * Adds a product to the shopping cart.
 *
 * @param {jQuery Object} $btn - The button object that triggers this function.
 * @param {number} product_id - The ID of the product to add to the cart.
 * @param {number} quantity - The quantity of the product to add.
 * @param {Object} properties - Additional properties related to the product.
 *
 */ $(document).ready(function() {
    // -----------------------------------------------
    // BREED CHOOSER
    // -----------------------------------------------
    if (!Modernizr.touchevents && !Modernizr.pointerevents) {
        $(".breed-chooser").each(function(i, element) {
            $(element).find("select").on("chosen:ready", function() {
                $(element).find(".chosen-single").append("<i class='chevron down'></i>");
                setTimeout(function() {
                    $(element).fadeIn("slow");
                }, 500);
            });
        });
        $(".breed-chooser select").each(function(element) {
            $(element).chosen();
        });
        $(".breed-chooser select").each(function(element) {
            $(element).chosen().change(function() {
                window.location.href = $(this).val();
            });
        });
        if ($(".chosen-container").length > 0) $(".chosen-container").on("touchstart", function(e) {
            e.stopPropagation();
            e.preventDefault();
            $(this).trigger("mousedown");
        });
    } else {
        $(".breed-chooser").css({
            "display": "block",
            "padding": "10px 0 0 0",
            "border-bottom": "none"
        });
        $(".breed-chooser select").show();
        $(".breed-chooser").parents(".inner").css({
            "padding-left": "0px"
        });
        $(".breed-chooser select").change(function() {
            window.location.href = $(this).val();
        });
    }
    // -----------------------------------------------
    // HEADER BREED SELECTOR RANDOMIZER
    // -----------------------------------------------
    if ($("#header-breed-selector-images").length > 0) {
        var imgs_a = $("#header-breed-selector-images img");
        var img_a = imgs_a[Math.floor(Math.random() * imgs_a.length)];
        var breed_name = $(img_a).attr("data-breed-name");
        $('#header-breed-selector .breed-chooser select option[data-breed-name="' + breed_name + '"]').prop("selected", true);
        $("#header-breed-selector .breed-chooser select").trigger("chosen:updated");
        setTimeout(function() {
            $(img_a).parents("a").attr("href", $("#header-breed-selector .breed-chooser select").val());
            $(img_a).fadeIn("slow");
        }, 500);
    }
    //
    //
    // PRODUCT CARD CONTAINER
    // -----------------------------------------------
    // $('.product-card-container').click(function(e)
    // {
    // 	if (!$(e.target).is('a') && !$(e.target).parent().is('a'))
    // 	{
    // 		window.location.href = $(this).attr('href');
    // 	}
    // });
    // -----------------------------------------------
    // ADD TO CART BUTTON
    // -----------------------------------------------
    // $('#AddToCart').click(function(e) {
    //   e.preventDefault()
    //   var product_id = $(this).attr('data-item-id')
    //   var quantity = parseInt($('#Quantity').val())
    //   var properties = {}
    //   var $form = $(this).parents('form')
    //   $form.find('[name^="properties"]').each(function (i,v) {
    //     var start = $(this).attr('name').indexOf('[') + 1
    //     var end = $(this).attr('name').indexOf(']')
    //     var n = $(this).attr('name').substring(start, end)
    //     var v = $(this).val()
    //     properties[n] = v
    //   }).get()
    //   addToCart($(this), product_id, quantity, properties)
    // })
    // -----------------------------------------------
    // ADD TO CART MODAL
    // -----------------------------------------------
    function addToCartModal(product_id, quantity, properties) {
        $7dad3bb78525ed3f$var$queue(function() {
            return $.post("/cart/add.js", {
                quantity: quantity,
                id: product_id,
                properties: properties
            }, "json").done(function(variant) {
                $7dad3bb78525ed3f$var$queue(function() {
                    return $.get("/products/" + variant.handle + ".js", "json").done(function(product) {
                        var URL = buildVariantURL(variant, product);
                        var key = variant.key.replace(":", "-");
                        var $cart_line = $("#cart-modal").find("#cart-item-" + key);
                        if ($cart_line.length > 0) {
                            var current_qty = parseInt($cart_line.find(".item.qty input").val());
                            $cart_line.find(".item.qty input").val(current_qty + quantity);
                            var total = variant.price * (current_qty + quantity);
                            $cart_line.find(".item.total p").html(Shopify.formatMoney(total));
                        } else {
                            $("#cart-modal .cart-row-new").removeClass("cart-row-new");
                            $("#cart-modal #row-new-product-actions").remove();
                            var $product_box = $(_TEMPLATE_MINI_CART_PRODUCT);
                            $product_box.addClass("cart-row-new");
                            var key = variant.key.replace(":", "-");
                            $product_box.attr("id", "cart-item-" + key);
                            $product_box.find(".table-product-img").attr("href", URL);
                            $product_box.find(".table-product-img img").attr("src", variant.image);
                            var title = product.title;
                            var product_details = false;
                            if (variant.variant_title != "Default Title") {
                                var variant_details = "<span>" + variant.variant_title;
                                if (variant.properties) {
                                    variant_details += "<br/>";
                                    $.each(variant.properties, function(i, v) {
                                        variant_details += i + ": " + v + "<br/>";
                                    });
                                }
                                variant_details += "</span>";
                            }
                            if (variant_details) title += variant_details;
                            $product_box.find(".table-product-title").attr("href", URL).html(title);
                            $product_box.find(".item.price p").html(Shopify.formatMoney(variant.price));
                            $product_box.find(".item.qty input").val(quantity);
                            var total = variant.price * quantity;
                            $product_box.find(".item.total p").html(Shopify.formatMoney(total));
                            $product_box.find(".item.remove a").attr("href", "/cart/change/" + variant.id + "?quantity=0");
                            $product_box.insertAfter($("#cart-modal .cart-table .cart-header-row"));
                            var $new_product_actions_row = $("<tr class='cart-row-new' id='row-new-product-actions'><td colspan='6'><p>Successfully Added!</p> <a href='/cart' class='btn'>Checkout</a> <a href='' class='btn btn-continue-shopping'>Continue Shopping</a></td></tr>");
                            $new_product_actions_row.insertAfter($product_box);
                            if ($("#related-cart-sells").length > 0) {
                                $("#row-related-items").remove();
                                var $related_items_row = $("<tr id='row-related-items'><td colspan='6'></td></tr>");
                                $("#related-cart-sells").show().appendTo($related_items_row.find("td"));
                                $related_items_row.insertAfter($new_product_actions_row);
                                positionFeaturedBlocks();
                            }
                        }
                        $7dad3bb78525ed3f$var$updateCartTotals();
                        var inst = $("[data-remodal-id=cart-modal]").remodal();
                        inst.open();
                        setTimeout(function() {
                            positionFeaturedBlocks();
                        }, 500);
                        return;
                    });
                });
            }).fail(function(msg) {
            // handle failure
            });
        });
        return false;
    }
    function buildVariantURL(variant, product) {
        let URL = variant.url;
        if (product.tags.length > 0) $.each(product.tags, function(tag) {
            if (tag.indexOf("a:") !== -1) {
                let collection_title = tag.substring(tag.indexOf(":") + 1).trim();
                collection_title = collection_title.replace(" ", "-").toLowerCase();
                URL = "/collections/" + collection_title + variant.url;
            }
        });
        return URL;
    }
    // -----------------------------------------------
    // CONTINUE SHOPPING BUTTON
    // -----------------------------------------------
    $("#cart-modal").on("click", ".btn-continue-shopping", function(e) {
        e.preventDefault();
        let inst = $("[data-remodal-id=cart-modal]").remodal();
        inst.close();
        return false;
    });
    // -----------------------------------------------
    // CLOSE RELATED CART SELLS MODAL
    // -----------------------------------------------
    $("#cart-modal").on("click", "#btn-close-related-cart-sells", function(e) {
        e.preventDefault();
        $("#row-related-items").fadeOut("slow", function() {
            $(this).remove();
        });
        return false;
    });
    // -----------------------------------------------
    // REMOVE LINE ITEM FROM CART IN MODAL
    // -----------------------------------------------
    $("#cart-modal").on("click", ".remove-item-from-cart", (e)=>{
        e.preventDefault();
        //
        //
        // GET INDEX OF CURRENT ROW
        // NOTE THAT line_number FOR SHOPIFY CART IS 1-based INDEX
        // WHEREAS ROW INDEX IS 0-based.
        // BUT THE FIRST TABLE ROW IS THE HEADER, SO ALL IS WELL...
        //
        //
        var $row = $(this).parents("tr.cart-item");
        var index = $("#cart-modal tr").index($row);
        $7dad3bb78525ed3f$var$queue(()=>{
            return $.post("/cart/change.js", {
                quantity: 0,
                line: index
            }, ()=>{}, "json").done((cart)=>{
                if ($row.hasClass("cart-row-new")) $(".cart-row-new").fadeOut("slow", ()=>{
                    $(this).remove();
                });
                else $row.fadeOut("slow", ()=>{
                    $(this).remove();
                });
                $7dad3bb78525ed3f$var$updateCartTotals();
            });
        });
        return false;
    });
    $(".cart-table .remove a").on("click", function(e) {
        e.preventDefault();
        const href = $(this).attr("href");
        const lineIndex = parseInt(href.match(/line=(\d+)/)[1]);
        const $currentItem = $(this).closest(".cart-item");
        $7dad3bb78525ed3f$var$removeCartLineItem(lineIndex);
        $currentItem.fadeOut(300, function() {
            $7dad3bb78525ed3f$var$updateCartTotals(()=>{
                window.location.reload();
            });
        });
    });
    //-----------------------------------------------
    // UPDATE CART
    // -----------------------------------------------
    $("#cart-modal").on("click", "#btn-update-cart", function(e) {
        e.preventDefault();
        let updates = new Array();
        $("#cart-modal .cart-table input.quantity").each(function() {
            updates.push($(this).val());
        });
        $7dad3bb78525ed3f$var$queue(function() {
            return $.post("/cart/update.js", {
                updates: updates
            }, "json").done(function(cart) {
                $.each(updates, function(i, v) {
                    if (v == 0) $("#cart-modal .cart-table tr").eq(i + 1).remove();
                });
                $.each(cart.items, function(i, item) {
                    $("#cart-modal .cart-table .item.total").eq(i + 1).find("p").html(Shopify.formatMoney(item.line_price));
                });
                $7dad3bb78525ed3f$var$updateCartTotals();
            }).fail(function() {
                alert("The quantity that you entered is not available. Please select a lower quantity to continue");
            });
        });
        return false;
    });
    // -----------------------------------------------
    // PRODUCT IMAGES
    // -----------------------------------------------
    $(".product-single__thumbnail").click(function(e) {
        e.preventDefault();
        $("#product-image-main").trigger("zoom.destroy");
        let img_src = $(this).find(".product-img-large").attr("src");
        let img_src_zoom = $(this).attr("data-zoom");
        if (img_src) {
            $("#ProductPhotoImg").attr("src", img_src);
            $("#product-image-main").attr("data-zoom", img_src_zoom);
        }
        return false;
    });
    $("#product-image-zoom-toggle, #product-image-main").click(function(e) {
        e.preventDefault();
        if (Modernizr.mq("(max-width: 1024px)")) {
            if ($(e.currentTarget).attr("id") == "product-image-main") return false;
        }
        let $productImageMain = $("#product-image-main");
        if ($(this).hasClass("zoom-enabled")) {
            $productImageMain.trigger("zoom.destroy");
            $(this).removeClass("zoom-enabled");
        } else {
            $(this).addClass("zoom-enabled");
            var productImgSrc = $productImageMain.attr("data-zoom");
            $productImageMain.zoom({
                url: productImgSrc,
                callback: function() {
                    $container = $productImageMain;
                    $zoomedImage = $(this);
                    let offsetWidth = ($container.outerWidth() - $zoomedImage.outerWidth()) / 2;
                    let offsetHeight = ($container.outerHeight() - $zoomedImage.outerHeight()) / 2;
                    $(this).css({
                        top: Math.round(offsetHeight * 100) / 100,
                        left: Math.round(offsetWidth * 100) / 100
                    });
                }
            });
        }
        return false;
    });
    // -----------------------------------------------
    // CUSTOMER ACCOUNTS
    // -----------------------------------------------
    $("#btn-forgot-password").click(function(e) {
        e.preventDefault();
        $("#form-container-login").hide();
        $("#form-container-reset-password").show();
        return false;
    });
    $("#btn-cancel-reset-password").click(function(e) {
        e.preventDefault();
        $("#form-container-reset-password").hide();
        $("#form-container-login").show();
        return false;
    });
    if (window.location.hash == "#recover") {
        $("#form-container-login").hide();
        $("#form-container-reset-password").show();
    }
    // -----------------------------------------------
    // ALERT MAX QUANTITY ON CART PAGE
    // -----------------------------------------------
    $("[max]").change(function() {
        var max = parseInt(jQuery(this).attr("max"), 10) || 10000;
        var value = parseInt(jQuery(this).val(), 10) || 0;
        if (value > max) {
            alert("We only have " + max + " of this item in stock");
            $(this).val(max);
        }
    });
    // -----------------------------------------------
    // VIEW TOGGLE
    // -----------------------------------------------
    $("#view-toggle a").click(function(e) {
        e.preventDefault();
        $("#view-toggle a").removeClass("active");
        $(this).addClass("active");
        if ($(this).attr("data-view") == "grid") {
            $(".collection-grid").removeClass("section-product-boxes-list");
            Cookies.set("collection-view", "grid");
        } else if ($(this).attr("data-view") == "list") {
            $(".collection-grid").addClass("section-product-boxes-list");
            Cookies.set("collection-view", "list");
        }
        return false;
    });
    // --------------------------------
    // CART PAGE - INCREMENT QUANTITY
    // --------------------------------
    $(".cart-table input.quantity").on("change", function() {
        const $target = $(this);
        const lineItemKey = $target.context.dataset.key;
        const lineItemQuantity = $target.context.value;
        if (lineItemQuantity < 1) {
            alert("Please enter an larger quantity or remove the item from cart");
            return;
        }
        $7dad3bb78525ed3f$var$updateCartLineItem(lineItemKey, lineItemQuantity);
    });
    // --------------------------------
    // Updates variant in cart
    // --------------------------------
    $(".cart-table div.properties").on("change", (e)=>{
        const $target = $(e.target) // the select element
        ;
        const lineItemOriginalKey = $target.attr("data-key") // original key from the select's data attribute
        ;
        const lineItemKey = $target.attr("data-key").replace(":", "-") // line item key from the select's data attribute
        ;
        const $currentItem = $("#cart-item-" + lineItemKey) // the current item in the cart
        ;
        const $options = $currentItem.find(".cart-select-option option:selected") // options for the current item
        ;
        const variants = $currentItem.data("variants") // variants for the current item -- variants type is Object
        ;
        const removeIndex = $currentItem.data("index") // index of the current item
        ;
        const lineItemQuantity = $currentItem.find(".input-quantity").val() // quantity of the current item
        ;
        const $properties = $currentItem.find(".property") // current properties for the current item
        ;
        let variant = "" // string to hold the variant
        ;
        // Check if there are an option:selected
        if ($options.length > 0) // Loop through each option and add its value to the variant string
        $options.each((i)=>{
            variant += $options[i].value.replace(/"/g, "in");
            if (i < $options.length - 1) variant += "/";
        });
        else {
            for(const key in variants)if (variants.hasOwnProperty(key)) variant += key;
        }
        let properties = {};
        $properties.each((i)=>{
            // get the name of the property
            const propertyName = $properties[i].name;
            // get the value of the property
            const propertyValue = $properties[i].value;
            // add the property to the properties object
            properties[propertyName] = propertyValue;
        });
        if ($target.context.tagName === "INPUT") properties[$target.context.name] = $target.context.value;
        // Get the variant ID for the selected variant
        let variantID = variants[variant]?.id ?? null;
        // If the variant ID is undefined, the variant is unavailable, so alert the user and reset the select to the previously selected option
        if (variantID === undefined) {
            alert('Variant "' + variant + '" is unavailable at this time');
            // Loop through each option and set the select to the previously selected option
            $options.each((i)=>{
                $options[i].selected = $options[i].defaultSelected;
            });
            return;
        }
        // Update select width
        initCartSelectWidth1($target);
        // If the variant ID and quantity are valid, remove the current item from the cart and add it back with the new variant ID and quantity
        if (lineItemOriginalKey && variantID && lineItemQuantity && removeIndex) // First, remove the old item
        $7dad3bb78525ed3f$var$updateCartLineItemVariant(lineItemOriginalKey, variantID, lineItemQuantity, removeIndex);
    });
    // --------------------------------
    // CONDITIONALLY sets requred arrtibure on fields
    // --------------------------------
    let lastVariantId = null;
    function updateEngravingFields() {
        const variantId = document.querySelector('input[name="id"]')?.value;
        if (!variantId || variantId === lastVariantId) return;
        lastVariantId = variantId;
        // let embroideryOptionSelected;
        const embroiderySelectElement = document.querySelectorAll(".product-form__select");
        const embroideryOptionSelected = embroiderySelectElement?.length > 1 ? embroiderySelectElement[1] : embroiderySelectElement[0];
        const embroideryValue = embroideryOptionSelected?.value.toLowerCase();
        const engravingInputs = document.querySelectorAll(".product-form__input.product-form__input--has-instructions");
        const productAllowsEngraving = window?.productEngravingEnabled === true;
        engravingInputs.forEach((input)=>{
            if (productAllowsEngraving && (embroideryValue?.includes("engraving") || embroideryValue?.includes("yes"))) {
                input.disabled = false;
                input.required = true;
            } else if (productAllowsEngraving && (!embroideryValue?.includes("engraving") || embroideryValue?.includes("no"))) {
                input.disabled = true;
                input.required = false;
            } else {
                input.disabled = false;
                input.required = false;
            }
            // Reset validation state
            input.setCustomValidity("");
            input.classList.remove("product-form__input--invalid");
            input.value = "";
        });
    }
    const variantPicker = document.querySelectorAll(".product__main__variant-picker")[0];
    if (variantPicker) {
        variantPicker.querySelectorAll("select").forEach((select)=>{
            select.addEventListener("change", updateEngravingFields);
        });
        // initial run
        updateEngravingFields();
    }
    // MutationObserver: detect Shopify DOM re-rendering
    const observerTarget = document.querySelector("form.product-form") || document.body;
    const observer = new MutationObserver(updateEngravingFields);
    observer.observe(observerTarget, {
        childList: true,
        subtree: true
    });
    // --------------------------------
    // CART PAGE - Change Items Options Value
    // --------------------------------
    const initCartSelectWidth1 = (select)=>{
        // Create a temporary element to measure the width of the selected option's text
        let $temp = $("<span>").html(select.find("option:selected").text()).appendTo("body");
        let width = $temp.width();
        $temp.remove();
        // Apply a buffer to ensure the text isn't cut off
        const calculateBuffer = (width)=>{
            if (width == 0) return 200;
            if (width < 26) return 10;
            if (width > 150) return 80;
            if (width < 50) return 20;
            return 30 + 0.5 * (width - 50);
        };
        width += calculateBuffer(width);
        // Set the width of the select element
        select.width(width);
    };
    // Loop through each select element in the cart table
    $(".cart-table select.cart-select").each((index, option)=>{
        // Get a jQuery object of the current select element
        let $option = $(option);
        // Run the function to set the width of the select element
        initCartSelectWidth1($option);
    });
    // If you want to update the width whenever an option is selected, you can add this event listener
    $(".cart-table select.cart-select").change((event)=>{
        initCartSelectWidth1($(event.target));
    });
    // -----------------------------------------------
    // DISCOUNTED PRODUCTS REQUIRE PAGE RELOAD ON QUANTITY UPDATE
    // -----------------------------------------------
    $(".cart-table input.quantity-discount").on("change", function(e) {
        var $cell = $(this).parents("td");
        if ($cell.find(".btn-update-quantity").length < 1) $cell.append("<button type='submit' class='btn btn-primary btn-update-quantity' style='padding: 5px 10px;font-size:.8em;letter-spacing:.05em;'>Update</button>");
    });
    // --------------------------------
    // CART HOVER MODAL FUNCTIONALITY
    // --------------------------------
    // Elements
    const cartIcon = document.querySelector(".logo-bar__links #cart-icon");
    const cartWrapper = document.querySelector(".cart-message-wrapper");
    const cartExitButton = document.querySelector(".cart-message__close");
    if (cartIcon) {
        // Holds the ID returned by setTimeout to be cleared later once the user stops hovering
        let hoverCheckTimeout = null;
        // Hide cart modal when no longer hovering over icon or modal after checking hover state
        function checkHoverState() {
            clearTimeout(hoverCheckTimeout);
            hoverCheckTimeout = setTimeout(()=>{
                const stillHovering = cartIcon.matches(":hover") || cartWrapper?.matches(":hover");
                if (!stillHovering) (0, $6Ny6s.hideCartModal)();
            }, 250);
        }
        // Show modal on hover
        cartIcon.addEventListener("mouseenter", (0, $6Ny6s.showCartHoverPreview));
        // Check when user leaves hover over cart icon
        cartIcon.addEventListener("mouseleave", checkHoverState);
        // Check when user leaves hover over cart message
        cartWrapper?.addEventListener("mouseleave", checkHoverState);
        // Allow manual close with "X" button
        cartExitButton?.addEventListener("click", (0, $6Ny6s.hideCartModal));
    }
    /*
	Cookies.set('name', 'value')
	Cookies.get('name')
	Cookies.get() // => { name: 'value' }
	Cookies.remove('name')
	Cookies.set('name', { foo: 'bar' })
	Cookies.getJSON('name') // => { foo: 'bar' }
	*/ if (Cookies.get("collection-view") == "list") $("#view-toggle a[data-view=list]").click();
    // -----------------------------------------------
    // RECENTLY VIEWED
    // -----------------------------------------------
    var recently_viewed_max = 4;
    var recently_viewed = Cookies.getJSON ? Cookies.getJSON("recently-viewed") : [];
    //console.log('RECENTLY VIEWED');
    //console.log(recently_viewed);
    // loadRecentlyViewed();
    addToRecentlyViewed();
    // Not called any where
    // const loadRecentlyViewed = function (callback) {
    // 	if ($('.recently-viewed-container').length > 0 && recently_viewed && recently_viewed.length > 0) {
    // 		// $('.section-recently-viewed').show();
    // 		// $('.section-recently-viewed .section-header').show();
    // 		$.each(recently_viewed, function(i,url) {
    // 			$('#featured-block-recently-viewed').append("<li class='product-box product-box-loading product-card'></li>");
    // 			$($('.recently-viewed-container .product-box')[i]).show();
    // 			$.get(url, function(html) {
    // 				var product_box = $(html).find('#product-box-template').html();
    // 				var $product_box_contents = $(product_box).html();
    // 				var $pb = $($('.recently-viewed-container .product-box')[i]);
    // 				$pb.html($product_box_contents);
    // 				$pb.removeClass('product-box-loading');
    // 				if (callback) callback($pb.get()[0])
    // 			}).done(function(e) {
    // 				positionFeaturedBlocks();
    // 				setTimeout(function() {
    // 					positionFeaturedBlocks();
    // 				}, 500);
    // 			}).fail(function(msg) {
    // 			});
    // 		});
    // 	}
    // }
    function addToRecentlyViewed() {
        let product_page_url = window.location.href.match(/.*\/products\/.*/g);
        if (product_page_url && product_page_url[0]) {
            let the_url = product_page_url[0].split(/[?#]/)[0];
            if (recently_viewed) var urls = recently_viewed;
            else var urls = Array();
            if ($.inArray(the_url, urls) == -1) {
                if (urls.length >= recently_viewed_max) urls.shift();
                urls.push(the_url);
            }
            Cookies.set("recently-viewed", urls);
        }
    }
});


(function() {
    const initPromoSlider = ()=>{
        const devices = [
            "desktop",
            "mobile"
        ];
        devices.forEach((device)=>{
            const swiperSelector = `#promo-bar.${device} .promo-bar__swiper`;
            const container = document.querySelector(swiperSelector);
            if (container) setupSwiper(container, device, swiperSelector);
        });
    };
    const setupSwiper = (container, device, selector)=>{
        const slides = container.querySelectorAll(".swiper-slide");
        const promoBar = container.closest("#promo-bar");
        // fall back to the first slide's background color if not set
        const firstSlide = slides[0];
        const defaultBg = firstSlide?.style.backgroundColor;
        const autoScrollEnabled = container.getAttribute("data-auto-scroll") === "true";
        const scrollSpeed = parseInt(container.getAttribute("data-auto-scroll-speed"), 10) * 1000;
        const config = {
            loop: slides.length > 1,
            slidesPerView: 1,
            centerSlides: true,
            centerSlidesBounds: true,
            allowTouchMove: device === "mobile",
            autoplay: autoScrollEnabled && slides.length > 1 ? {
                delay: scrollSpeed,
                disableOnInteraction: false
            } : false,
            on: {
                init (swiper) {
                    if (defaultBg) promoBar.style.backgroundColor = defaultBg;
                },
                slideChange (swiper) {
                    const activeSlide = swiper.slides[swiper.activeIndex];
                    const bg = activeSlide?.style.backgroundColor || defaultBg;
                    if (bg) promoBar.style.backgroundColor = bg;
                }
            }
        };
        let swiper = new Swiper(container, config);
        if (Shopify.designMode) {
            document.addEventListener("shopify:section:load", (evt)=>{
                if (evt.detail.sectionId === "promo-bar") {
                    const newContainer = evt.target.querySelector(selector);
                    if (newContainer) swiper = new Swiper(newContainer, config);
                }
            });
            document.addEventListener("shopify:section:unload", (evt)=>{
                if (evt.detail.sectionId === "promo-bar") swiper.destroy();
            });
            document.addEventListener("shopify:block:select", (evt)=>{
                const block = evt.target;
                const index = Array.from(block.parentNode.children).indexOf(block);
                if (evt.detail.load) swiper = new Swiper(selector, {
                    initialSlide: index,
                    ...config
                });
                else swiper.slideTo(index);
            });
        }
    };
    initPromoSlider();
})();


(function($) {
    "use strict";
    var pluginName = "dropdown", namespace = "plugin_" + pluginName;
    /*-------------------------------------------- */ /** Plugin Defaults */ /*-------------------------------------------- */ var defaults = {
        trigger: null,
        displayEvent: "click",
        hideDelay: 3000,
        mouseLeaveDelay: 500,
        toggledClass: "active",
        showCallback: $.noop,
        hideCallback: $.noop,
        dismissOnDocumentClick: true
    };
    /*-------------------------------------------- */ /** Helpers */ /*-------------------------------------------- */ function callMethod(instance, method, args) {
        if ($.isFunction(instance[method])) instance[method].apply(instance, args);
    }
    /*-------------------------------------------- */ /** Plugin Constructor */ /*-------------------------------------------- */ function Plugin(el, opts) {
        this.options = $.extend({}, defaults, opts);
        this.$el = $(el);
        this._init();
    }
    Plugin._hideActiveDropdown = function() {
        if (Plugin._activeDropdown) Plugin._activeDropdown.hide();
    };
    Plugin._setActiveDropdown = function(active) {
        // hide the current active dropdown (may or may not exist)
        Plugin._hideActiveDropdown();
        // set the new dropdown as the active one
        Plugin._activeDropdown = active;
    };
    $.extend(Plugin.prototype, {
        /*-------------------------------------------- */ /** Private Methods */ /*-------------------------------------------- */ _init: function() {
            this._addListeners();
        },
        _addMouseLeaveDelayListeners: function() {
            var self = this;
            this.$el.on("mouseleave", function(e) {
                // Fixes firefox and other browsers that fire mouseleave event when opening select element
                if ($(e.target).is("select") && self.$el.has(e.target).length > 0) {
                    e.stopPropagation();
                    return;
                }
                self._mouseLeaveTimeout = setTimeout($.proxy(self.hide, self), self.options.mouseLeaveDelay);
            });
            this.$el.on("mouseenter", function(e) {
                self._clearTimeouts();
            });
        },
        _addListeners: function() {
            var self = this;
            if (this.options.mouseLeaveDelay) self._addMouseLeaveDelayListeners();
            if (this.options.trigger) $(this.options.trigger).on(this.options.displayEvent, function(e) {
                e.preventDefault();
                if (Plugin._activeDropdown != self) {
                    e.stopPropagation();
                    self.show();
                }
            });
            if (!Plugin._hasDocumentClickBeenAdded) {
                $(document).on("click." + namespace, function(e) {
                    // If any DOM element that *is not* the dropdown is clicked,
                    // then hide the dropdown element.
                    if (self.options.dismissOnDocumentClick && Plugin._activeDropdown && !$.contains(Plugin._activeDropdown.$el.get(0), e.target) && e.target != self.$el.get(0)) Plugin._activeDropdown.hide();
                });
                Plugin._hasDocumentClickBeenAdded = true;
            }
        },
        _clearTimeouts: function() {
            clearTimeout(this._hideTimeout);
            clearTimeout(this._mouseLeaveTimeout);
        },
        _startHideTimeout: function() {
            if (!this.options.hideDelay) return;
            var self = this;
            // start a timeout to hide the dropdown after hideDelay threshold is eclipsed
            this._hideTimeout = setTimeout(function() {
                self.hide();
            }, this.options.hideDelay);
        },
        /*-------------------------------------------- */ /** Public Methods */ /*-------------------------------------------- */ show: function() {
            // if the element is already shown, return
            if (this.$el.hasClass(this.options.toggledClass)) return;
            this._startHideTimeout();
            Plugin._setActiveDropdown(this);
            this.$el.addClass(this.options.toggledClass);
            this.options.showCallback();
        },
        hide: function() {
            // if the dropdown is already hidden, return
            if (!this.$el.hasClass(this.options.toggledClass)) return;
            Plugin._activeDropdown = null;
            this._clearTimeouts();
            this.$el.removeClass(this.options.toggledClass);
            this.options.hideCallback();
        },
        destroy: function() {
            this.$el.off("mouseleave, mouseenter");
            if (Plugin._hasDocumentClickBeenAdded) $(document).off("click." + namespace);
            if (this.options.trigger) $(this.options.trigger).off(this.options.displayEvent);
        }
    });
    /*-------------------------------------------- */ /** Plugin Definition */ /*-------------------------------------------- */ $.fn.dropdown = function(options) {
        var method = false, methodArgs = arguments;
        if (typeof options == "string") method = options;
        return this.each(function() {
            var plugin = $.data(this, namespace);
            if (!plugin) $.data(this, namespace, new Plugin(this, options));
            else if (method) callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
        });
    };
})(jQuery);


(()=>{
    const $navCategoryNoDropdown = $(".main-menu__nav__category:not([data-menu-id])");
    const $parent = $(".main-menu__dropdowns");
    const $dropdowns = $(".main-menu__dropdown");
    const $overlayBackground = $(".site-wrap__overlay");
    $dropdowns.each((i, el)=>{
        const $el = $(el);
        const elID = $el.attr("id");
        const $trigger = $(`[data-menu-id="${elID}"]`);
        $el.dropdown({
            trigger: $trigger,
            displayEvent: "mouseover",
            toggledClass: "is-open",
            showCallback: showMenu,
            hideCallback: hideMenu,
            hideDelay: null,
            mouseLeaveDelay: 1
        });
        function hideMenu() {
            $el.siblings().dropdown("hide");
            $parent.removeClass("is-open");
            $trigger.removeClass("is-open");
            if (!$parent.hasClass("is-open")) {
                $el.addClass("is-closing");
                $overlayBackground.removeClass("is-open");
            }
        }
        function showMenu() {
            $el.siblings().removeClass("is-closing");
            $parent.addClass("is-open");
            $trigger.addClass("is-open");
            $overlayBackground.addClass("is-open");
        }
        $navCategoryNoDropdown.on("mouseover", ()=>{
            $el.dropdown("hide");
        });
    });
})();


(()=>{
    const $mobileNavWrap = $(".mobile-header__wrap");
    const $mobileDropdownTrigger = $(".mobile-header__menu-icon");
    const $mobileDropdownsWrap = $(".main-menu-mobile__dropdowns");
    const $mobileSearchTrigger = $(".mobile-header__search");
    const $mobileSearchWrap = $(".mobile-header__search-bar");
    $mobileDropdownTrigger.on("click", ()=>{
        $mobileSearchTrigger.removeClass("is-open");
        $mobileSearchWrap.removeClass("is-open");
        if ($mobileDropdownTrigger.hasClass("is-open")) {
            $mobileDropdownTrigger.removeClass("is-open");
            $mobileNavWrap.removeClass("is-open");
            $mobileDropdownsWrap.removeClass("is-open");
        } else {
            $mobileDropdownTrigger.addClass("is-open");
            $mobileNavWrap.addClass("is-open");
            $mobileDropdownsWrap.addClass("is-open");
        }
    });
    $mobileSearchTrigger.on("click", ()=>{
        $mobileDropdownTrigger.removeClass("is-open");
        $mobileNavWrap.removeClass("is-open");
        $mobileDropdownsWrap.removeClass("is-open");
        if ($mobileSearchTrigger.hasClass("is-open")) {
            $mobileSearchTrigger.removeClass("is-open");
            $mobileSearchWrap.removeClass("is-open");
        } else {
            $mobileSearchTrigger.addClass("is-open");
            $mobileSearchWrap.addClass("is-open");
        }
    });
    const subcategoryDropdowns = [
        ...document.querySelectorAll(".main-menu-mobile__dropdown")
    ].filter((dropdown)=>dropdown.querySelector(".main-menu-mobile__subcategory-wrap--has-dropdown")).map((dropdown)=>({
            el: dropdown,
            accordion: new Accordion(dropdown, {
                elementClass: "main-menu-mobile__subcategory-wrap--has-dropdown",
                triggerClass: "main-menu-mobile__dropdown__subcategory-icon",
                panelClass: "main-menu-mobile__dropdown__subcategory-items",
                activeClass: "is-open"
            })
        }));
    new Accordion(".main-menu-mobile__dropdowns", {
        elementClass: "main-menu-mobile__dropdown-wrap--has-dropdown",
        triggerClass: "main-menu-mobile__category-icon",
        panelClass: "main-menu-mobile__dropdown",
        activeClass: "is-open",
        beforeClose: (el)=>{
            const panelId = el.id.split("-").join("-panel-");
            const subcategoryDropdown = subcategoryDropdowns.find((dropdown)=>dropdown.el.id === panelId);
            if (!subcategoryDropdown) return;
            subcategoryDropdown.accordion.closeAll();
            // Below we are manually toggling false aria-expanded's due to a bug with
            // manually closing dropdowns with accordion-js
            const expandedAreas = [
                ...subcategoryDropdown.el.querySelectorAll('[aria-expanded="true"]')
            ];
            if (expandedAreas) expandedAreas.forEach((expanded)=>expanded.setAttribute("aria-expanded", false));
        }
    });
})();



var $6Ny6s = parcelRequire("6Ny6s");
class $b11afca3a6ee5106$var$CartMessage extends HTMLElement {
    constructor(){
        super();
        this._onTransitionEnd = this._onTransitionEnd.bind(this);
        this._isOpen = false;
        this.message = document.getElementById("cart-message");
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.message.addEventListener("keyup", (evt)=>evt.code === "Escape" && this.closest());
        this.querySelectorAll('button[type="button"]').forEach((closeButton)=>closeButton.addEventListener("click", this.closest.bind(this)));
        this._timeout = null;
    }
    /**
     * Opens the message
     */ open() {
        this._resetTimeout();
        // If already open, reset the animation so it can appear when spammed
        if (this._isOpen) {
            this.message.classList.remove("animate", "active");
            // Force reflow to allow re-triggering the animation
            this.message.offsetWidth;
        }
        this._isOpen = true;
        // Remove any previous transitionend event listener to prevent stacking or duplicate
        this.message.removeEventListener("transitionend", this._onTransitionEnd);
        // Show modal
        this.message.classList.add("animate", "active");
        this.message.style.display = "block";
        // Add a new transitionend event listener to handle focus and accessibility after the animation
        this.message.addEventListener("transitionend", this._onTransitionEnd);
        // Set up an event listener on the document body to detect clicks
        document.body.addEventListener("click", this.onBodyClick);
        // Set up an event listener on the message to detect interactions and reset the timeout
        this.message.addEventListener("mousemove", this._resetTimeout.bind(this));
        this.message.addEventListener("click", this._resetTimeout.bind(this));
        this.message.addEventListener("keydown", this._resetTimeout.bind(this));
    }
    /**
     * Handles the transition ends to ensure that focus is set correctly
     */ _onTransitionEnd() {
        // Once the transition (animation) is complete, set the focus to the message element
        this.message.focus();
        // Ensure that keyboard focus remains within the message for better accessibility
        trapFocus(this.message);
    }
    /**
     * Closes the message
     */ close() {
        // Remove the 'active' class from the message
        this.message.classList.remove("active");
        this.message.style.display = "none";
        // Remove the previously added click event listener from the document body, ensuring that it won't interfere with other interactions after the message is closed
        document.body.removeEventListener("click", this.onBodyClick);
        // More clean-up to prevent any stacking of event listeners
        this.message.removeEventListener("transitionend", this._onTransitionEnd);
        // Clear the timeout
        if (this._timeout) clearTimeout(this._timeout);
        this._isOpen = false;
    }
    /**
     * Render the contents of a component (e.g., a cart) based on a given state
     *
     * @param {Object} parsedState - The state data used to update the content
     */ renderContents(parsedState) {
        this.cartItemKey = parsedState.key;
        this.getSectionsToRender().forEach((section)=>{
            document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        // Set event listeners for quantity selector
        const productType = parsedState.product_type;
        const quantitySelector = document.querySelector(".quantity-selector");
        const minusButton = quantitySelector.querySelector(".quantity-selector__button.minus");
        const plusButton = quantitySelector.querySelector(".quantity-selector__button.plus");
        const quantityInput = quantitySelector.querySelector('input[type="number"]');
        if (productType === "Report") quantitySelector.style.display = "none";
        minusButton.addEventListener("click", ()=>{
            $b11afca3a6ee5106$var$updateItemQuantity(this.cartItemKey, "decrement");
        });
        plusButton.addEventListener("click", ()=>{
            $b11afca3a6ee5106$var$updateItemQuantity(this.cartItemKey, "increment");
        });
        quantityInput.addEventListener("input", ()=>{
            $b11afca3a6ee5106$var$updateQuantity(this.cartItemKey);
        });
        // Set the initial state of the minus button based on the quantity
        const initialQuantity = document.getElementById(`quantity-input-${this.cartItemKey}`).value;
        this._updateMinusButtonState(this.cartItemKey, initialQuantity);
        this.open();
        (0, $6Ny6s.showAddToCartPreview)(this.cartItemKey);
    }
    // New method to update the minus button state
    _updateMinusButtonState(itemKey, quantity) {
        const minusButton = document.getElementById(`minus-button-${itemKey}`);
        if (minusButton) minusButton.disabled = quantity <= 1;
    }
    /**
     * Returns an array of sections that need to be rendered or updated.
     * Each section is represented by an object containing its unique ID and, optionally, a specific selector.
     *
     * @returns {Array} An array of section objects.
     */ getSectionsToRender() {
        return [
            {
                id: "cart-item",
                selector: `[id="cart-item-${this.cartItemKey}"]`
            }
        ];
    }
    /**
     * Parses a given HTML string, extracts the inner HTML of the element matched by the provided selector,
     * and returns it.
     *
     * @param {string} html - The HTML string to parse and extract content from.
     * @param {string} [selector=] - The CSS selector to match the desired element.
     *
     * @returns {string} The inner HTML of the matched element.
     */ getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }
    /**
     * Handles click events on the body to determine if specific actions (like closing the message) should be taken
     *
     * @param {Event} evt - The click event object
     */ handleBodyClick(evt) {
        // Get the element that was clicked.
        const target = evt.target;
        const closeButton = target.closest(".cart-message__close");
        // Check if the clicked element is NOT the message itself and is also NOT a descendant of 'cart-message'
        if (target !== this.message && !target.closest(".cart-message") || closeButton) // If the clicked element is NOT the message itself and is also NOT a descendant of 'cart-message', close the message
        this.close();
    }
    /**
     * Resets the timeout for closing the message.
     */ _resetTimeout() {
        // Clear any existing timeout
        if (this._timeout) clearTimeout(this._timeout);
        // Set a new timeout to close the message after 3 seconds
        this._timeout = setTimeout(()=>{
            this.close();
        }, 3000);
    }
    setActiveElement(element) {
        this.activeElement = element;
    }
}
async function $b11afca3a6ee5106$var$updateCart(itemKey, quantity) {
    const data = {
        id: itemKey,
        quantity: quantity
    };
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    };
    return fetch("/cart/change.js", options) // Ensure this returns a promise
    .then((response)=>response.json());
}
function $b11afca3a6ee5106$var$getCartTotal() {
    return new Promise((resolve, reject)=>{
        $.get("/cart.js", ()=>{}, "json").done((cart)=>{
            resolve(cart.original_total_price);
        }).fail((error)=>{
            reject(error);
        });
    });
}
async function $b11afca3a6ee5106$var$updateItemQuantity(itemKey, changeType) {
    const input = document.getElementById(`quantity-input-${itemKey}`);
    let quantity = parseInt(input.value, 10);
    if (changeType === "increment") quantity++;
    else if (changeType === "decrement" && quantity > 1) quantity--;
    // Update input value and item total price
    input.value = quantity;
    $b11afca3a6ee5106$var$updateItemTotalPrice(itemKey, quantity);
    // Update cart and wait for it to complete
    await $b11afca3a6ee5106$var$updateCart(itemKey, quantity);
    // Fetch and display updated cart total
    await $b11afca3a6ee5106$var$updateCartTotalDisplay();
}
async function $b11afca3a6ee5106$var$updateCartTotalDisplay() {
    try {
        // Fetch and display updated cart total
        const totalCart = await $b11afca3a6ee5106$var$getCartTotal();
        const cartTotalElement = document.getElementById("cart-total");
        if (cartTotalElement) cartTotalElement.textContent = `Total: ${(0, $6Ny6s.formatMoney)(totalCart)}`;
    } catch (error) {
        console.error("Error fetching cart total:", error);
    }
}
function $b11afca3a6ee5106$var$updateItemTotalPrice(itemKey, quantity) {
    // Get the unit price of the item
    const eachPriceElement = document.getElementById(`item-each-price-${itemKey}`);
    const eachPrice = parseFloat(eachPriceElement.textContent.replace(/[^0-9.-]+/g, ""));
    // Compute the new total price for the item
    const totalPrice = eachPrice * quantity;
    // Update the displayed total price for the item
    const totalPriceElement = document.getElementById(`item-price-${itemKey}`);
    totalPriceElement.textContent = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(totalPrice);
    const cartMessageElement = document.querySelector("cart-message");
    if (cartMessageElement) cartMessageElement._updateMinusButtonState(itemKey, quantity);
}
async function $b11afca3a6ee5106$var$updateQuantity(itemKey) {
    const input = document.getElementById(`quantity-input-${itemKey}`);
    let quantity = parseInt(input.value, 10);
    if (quantity >= 1) {
        // Update item total price
        $b11afca3a6ee5106$var$updateItemTotalPrice(itemKey, quantity);
        // Update cart and wait for it to complete
        await $b11afca3a6ee5106$var$updateCart(itemKey, quantity);
        // After updating the cart, fetch and display updated cart total
        try {
            const totalCartElement = document.getElementById("cart-message-product__price-total");
            const totalCart = await $b11afca3a6ee5106$var$getCartTotal();
            let totalCartInDollars = totalCart / 100;
            totalCartElement.textContent = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(totalCartInDollars);
        } catch (error) {
            console.error("Error fetching cart total:", error);
        }
    }
}
customElements.define("cart-message", $b11afca3a6ee5106$var$CartMessage);


window.Alpine = (0, $f347e48613385d9c$export$2e2bcd8739ae039);

/*-------------------------------------------- */ /** Router */ /*-------------------------------------------- */ (parcelRequire("hRgcM")).then((router)=>{
    router.init();
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).start();
});

})();
//# sourceMappingURL=main.parcel.js.map
